export const DOMAIN = DOMAIN_API.VUE_APP_DOMAIN;

export const QLVB_DOMAIN = DOMAIN_API.QLVB_DOMAIN;

export const DOMAIN_AUTH = DOMAIN_API.VUE_APP_AUTH_DOMAIN;

export const DOMAIN_WORD = DOMAIN_API.VUE_APP_WORD_DOMAIN;

export const DOMAIN_COMMON = DOMAIN_API.VUE_APP_COMMON_DOMAIN;

export const DOMAIN_FILE_COMMON = DOMAIN_API.VUE_FILE_COMMON_DOMAIN;

export const API_VERSION = DOMAIN_API.VUE_APP_API_VERSION;

export const DOWN_LOAD_FILE = DOMAIN;

export const DOMAIN_API_HSLT  = DOMAIN_API.VUE_APP_DOMAIN_HSTL;

export const DOMAIN_FILE = DOMAIN_API.VUE_APP_DOMAIN_FILE;

export const ROUTE_NAME = {
  DANG_NHAP: "/dang-nhap",
  TRANG_CHU: "/trang-chu",
  REDIRECT: "/redirect",
  VAN_BAN_DI: {
    NAME: "/van-ban-di/",
    CHO_CAP_SO: "cho-cap-so",
    CHO_BO_CAP_SO: "cho-bo-cap-so",
    CHI_TIET_CAP_SO: "cho-cap-so/cap-so-va-ban-hanh",
    SUA_VAN_BAN_CHO_BAN_HANH: ":route/sua",
    SAO_CHEP_VAN_BAN_CAP_SO_BAN_HANH: ":route/sao-chep",
    CHO_BAN_HANH: "cho-ban-hanh",
    CHO_TRINH_KY: "cho-trinh-ky",
    YEU_CAU_TRA_LAI: "yeu-cau-tra-lai",
    TRINH_KY_TIEP_THEO: "trinh-ky-tiep-theo/:idVanBan",
    CHO_XU_LY: "cho-xu-ly-vb-di",
    DA_XU_LY: "da-xu-ly-vb-di",
    DA_BAN_HANH: "da-ban-hanh",
    CHO_Y_KIEN: "cho-y-kien",
    DA_CHO_Y_KIEN: "da-cho-y-kien",
    NOI_BO: "noi-bo",
    TRA_CUU: "tra-cuu-vb-di",
    QUAN_LY_GIU_SO: "quan-ly-giu-so",
    DANH_SACH: "",
    TAO_MOI: ":route/tao-moi",
    XEM: ":route/:idVanBan/:type",
    CHI_TIET_VAN_BAN_Di: "chi-tiet-van-ban/:idVanBan",
    WORD_ONLINE: "file/word-online/:idFile/:action",
    EXCEL_ONLINE: "file/excel-online/:idFile/:action",
    PDF_ONLINE: "file/pdf-online/:idFile/:action",
    NHAN_SO: "cho-cap-so/nhan-so",
    DA_TRA_LAI: "da-tra-lai",
    QUAN_LY_DOI_SO: "quan-ly-doi-so",
    XEM_LUONG: "xem-luong-van-ban-di/:idVanBan",
    BI_TRA_LAI: "bi-tra-lai",
    OCR: "ocr/van-ban-di",
  },
  TRA_CUU: "/tra-cuu-van-ban",
  VAN_BAN_DEN: {
    NAME: "/van-ban-den/",
    VT_THU: "danh-sach",
    TAO_MOI: ":route/tao-moi-van-ban-den",
    TRA_CUU: "tra-cuu",
    TRA_CUU_OLD: "tra-cuu-old",
    CHO_VAO_SO: "cho-vao-so",
    CHO_PHAN_XU_LY: "cho-phan-xu-ly",
    CHO_XU_LY: "cho-xu-ly",
    DANG_XU_LY: "dang-xu-ly",
    DA_XU_LY: "da-xu-ly",
    BI_TRA_LAI: "bi-tra-lai",
    DA_TRA_LAI: "da-tra-lai",
    CHO_Y_KIEN: "cho-y-kien-vb-den",
    DA_CHO_Y_KIEN: "da-cho-y-kien-vb-den",
    NHAN_DE_BIET: "nhan-de-biet",
    CHI_TIET: "chi-tiet-van-ban",
    TAO_PAKN: "tao-pakn",
    CHI_TIET_VAN_BAN_DEN: "chi-tiet-van-ban/:vanBanDenId",
    XEM: ":route/:vanBanDenId",
    SUA: ":route/sua/:vanBanDenId",
    THU_HOI: "thu-hoi",
    TRA_LAI: "tra-lai",
    XEM_LUONG: "xem-luong-van-ban-den/:vanBanDenId",
    YEU_CAU_THU_HOI: "yeu-cau-thu-hoi",
    BAO_CAO_LANH_DAO: "bao-cao-lanh-dao",
    WORD_ONLINE: "file/word-online/:idFile/:action",
    EXCEL_ONLINE: "file/excel-online/:idFile/:action",
    PDF_ONLINE: "file/pdf-online/:idFile/:action",
    OCR: "ocr/van-ban-den",
    YEU_CAU_CAP_NHAT: "yeu-cau-cap-nhat",
  },
  HO_SO_CONG_VIEC: {
    NAME: "/ho-so-cong-viec/",
    TRA_CUU: "tra-cuu-hscv",
    CHO_PHAN_XU_LY: "cho-phan-xu-ly-hscv",
    CHO_XU_LY: "cho-xu-ly-hscv",
    DANG_THUC_HIEN: "dang-thuc-hien-hscv",
    DA_KET_THUC: "da-ket-thuc-hscv",
    DA_TRA_LAI: "da-tra-lai-hscv",
    BI_TRA_LAI: "bi-tra-lai-hscv",
    CHO_CHO_Y_KIEN: "cho-cho-y-kien-hscv",
    DA_CHO_Y_KIEN: "da-cho-y-kien-hscv",
    THEM_MOI: ":route/them-moi",
    XEM: ":route/xem/:id",
    SUA: ":route/sua/:id",
    WORD_ONLINE: "file/word-online/:idFile/:action",
    EXCEL_ONLINE: "file/excel-online/:idFile/:action",
    PDF_ONLINE: "file/pdf-online/:idFile/:action",
  },
  HE_THONG: "/he-thong",
  HO_SO_LUU_TRU: {
    NAME: "/ho-so-luu-tru/",
    DANH_MUC_HO_SO: {
      NAME: "danh-muc-ho-so",
      THEM_MOI: "them-moi",
      SUA: "sua/:id",
      CHI_TIET: "chi-tiet/:id",
    },
    TINH_HINH_NOP_DANH_MUC: {
      NAME: "tinh-hinh-nop-danh-muc",
      THEM_MOI: "cai-dat-tinh-hinh",
    },
    HO_SO: "ho-so",
    LAP_HO_SO: {
      NAME: "lap-ho-so",
      THEM_MOI: "them-moi-ho-so",
      THEM_TAI_LIEU: {
        NAME: "/upload-tai-lieu",
        THEM_MOI: "them-tai-lieu",
      },
    },
    THU_THAP_TAI_LIEU: {
      NAME: "thu-thap-tai-lieu",
      YC_NOP_LUU_TAI_LIEU: "yc-nop-luu-tai-lieu",
      YC_GIU_LAI_TAI_LIEU: "yc-giu-lai-tai-lieu",
      MUC_LUC_HO_SO: {
        NAME: "muc-luc-ho-so",
        CHUA_TIEP_NHAN: "chua-tiep-nhan",
        DA_TIEP_NHAN: "da-tiep-nhan",
      },
      BIEN_BAN_BAN_GIAO_TAI_LIEU: "bien-ban-ban-giao-tai-lieu",
      HO_SO_VE_VIEC_THU_THAP_TAI_LIEU: "ho-so-ve-viec-thu-thap-tai-lieu",
      HO_SO_TAI_LIEU_DA_THU_THAP: "ho-so-tai-lieu-da-thu-thap",
    },
    KHAI_THAC_SU_DUNG_TAI_LIEU: "khai-thac-su-dung-tai-lieu",
    NOP_LUU_TAI_LIEU: "nop-luu-tai-lieu",
    HUY_TAI_LIEU_HET_GIA_TRI: "huy-tai-lieu-het-gia-tri",
    BAO_CAO: "bao-cao",
  },
  BAO_CAO: {
    NAME: "/bao-cao/",
    VAN_BAN_DI: "van-ban-di",
    VAN_BAN_DEN: "van-ban-den",
    VAN_BAN_TONG_HOP: "van-ban-tong-hop",
    NHIEM_VU: "nhiem-vu",
    SO_LUONG_VAN_BAN_DEN: "so-luong-van-ban-den",
  },
  NHIEM_VU: {
    NAME: "/nhiem-vu/",
    TAO: "/nhiem-vu/:route/tao-moi",
    CHI_TIET_CA_NHAN: "nhiem-vu-ca-nhan/:nhiemVuId",
    CHI_TIET_DON_VI: "tra-cuu-nhiem-vu-giao-don-vi/:nhiemVuId",
    CHI_TIET_DON_VI_GIAO: "nhiem-vu-don-vi-giao/:nhiemVuId",
    CHI_TIET_BO_GIAO: "nhiem-vu-bo-giao/:nhiemVuId",
    CHI_TIET_CP_GIAO: "nhiem-vu-vp-ttcp-giao/:nhiemVuId",
    CAP_NHAT: "/nhiem-vu/:route/sua-nhiem-vu/:nhiemVuId",
    IMPORT: "/nhiem-vu/import",
    CA_NHAN: "nhiem-vu-ca-nhan",
    DON_VI: "tra-cuu-nhiem-vu-giao-don-vi",
    XEM_LUONG: "xem-luong-nhiem-vu/:nhiemVuId",
    DON_VI_GIAO: "nhiem-vu-don-vi-giao",
    CP_GIAO: "nhiem-vu-vp-ttcp-giao",
    BO_GIAO: "nhiem-vu-bo-giao",
  },
  LUU_TRU_DIEN_TU: {
    NAME: "/luu-tru-dien-tu",
  },
  VAN_BAN: {
    NAME: "/van-ban/",
    DANH_SACH: "danh-sach",
    CHI_TIET: ":vanBanId",
    TAO: "tao",
  },
  CHUC_VU: {
    NAME: "/quan-ly-nhom-chuc-vu/",
    DANH_SACH: "/danh-sach",
    TAO: "/them-moi-nhom-chuc-vu",
    CAP_NHAT: "/sua-nhom-chuc-vu/:chucVuId",
    CHI_TIET: "/xem-nhom-chuc-vu/:chucVuId",
  },
  DON_VI: {
    NAME: "/quan-ly-don-vi/",
    DANH_SACH: "danh-sach",
    TAO: "them-moi-don-vi",
    CAP_NHAT: "sua-don-vi/:chucVuId",
    CHI_TIET: "xem-don-vi/:chucVuId",
  },
  CONG_VIEC: {
    NAME: "/cong-viec/",
  },
  QUAN_TRI_HE_THONG: {
    NAME: "/quan-tri-he-thong/",
    QUAN_LY_TEMPLATE: "quan-ly-template",
    VAN_BAN_ERROR: "van-ban-loi",
    QUAN_LY_LOG_HE_THONG: "quan-ly-log-he-thong",
    QUAN_LY_DANH_MUC_CRUD: "quan-ly-danh-muc-crud",
    QUAN_LY_LOAI_VAN_BAN: "quan-ly-loai-van-ban",
    QUAN_LY_LOAI_SO_VAN_BAN: "quan-ly-loai-so-van-ban",
    QUAN_LY_SO_VAN_BAN: "quan-ly-so-van-ban",
    QUAN_LY_DON_VI_NGOAI: "quan-ly-don-vi-ngoai",
    QUAN_LY_NHOM_LAM_VIEC: "quan-ly-nhom-lam-viec",
    QUAN_LY_DE_MUC: "quan-ly-de-muc",
    QUAN_LY_LINH_VUC: "quan-ly-linh-vuc",
    QUAN_LY_UY_QUYEN: "quan-ly-uy-quyen",
    CAU_HINH_UY_QUYEN: "cau-hinh-uy-quyen",
    QUAN_LY_NHOM_CONG_VIEC: "quan-ly-nhom-cong-viec",
    QUAN_LY_MAU_DU_THAO: {
      DANH_SACH: "quan-ly-mau-du-thao/",
      XEM: "quan-ly-mau-du-thao/:id/:route",
      TAO: "quan-ly-mau-du-thao/tao",
    },
    CAU_HINH_HE_THONG: "cau-hinh-he-thong",
    QUAN_LY_DON_VI_NOP_LUU: "quan-ly-don-vi-nop-luu",
  },
  SCAN_VAN_BAN: "/scan-van-ban",
  CHUA_CO_QUYEN: "/chua-co-quyen",
};

export const MENU_ROUTE_NAME = {
  TRANG_CHU: "Trang chủ",
  VAN_BAN_DI: {
    NAME: "Văn bản đi",
    CHO_CAP_SO: "Chờ cấp số",
    CHO_BO_CAP_SO: "Chờ Bộ cấp số",
    CHO_BAN_HANH: "Chờ ban hành",
    VAN_BAN_ERROR: "Văn bản đi ban hành lỗi",
    CHO_TRINH_KY: "Chờ trình ký",
    YEU_CAU_TRA_LAI: "Yêu cầu trả lại",
    CHO_XU_LY: "Chờ xử lý",
    DA_XU_LY: "Đã xử lý",
    DA_BAN_HANH: "Đã ban hành",
    CHO_Y_KIEN: "Chờ ý kiến",
    DA_CHO_Y_KIEN: "Đã cho ý kiến",
    NOI_BO: "Nội bộ",
    TRA_CUU: "Tra cứu",
    DANH_SACH: "Danh sách văn bản đi",
    TRINH_KY_TIEP_THEO: "Trình ký tiếp theo",
    QUAN_LY_GIU_SO: "Quản lý giữ số",
    NHAN_SO: "Giữ số",
    XEM_VAN_BAN_DI: "Chi tiết văn bản đi",
    SUA_VAN_BAN_DI: "Sửa văn bản",
    TAO_VAN_BAN_DI: "Tạo văn bản",
    SAO_CHEP_VAN_BAN_DI: "Sao chép văn bản",
    WORD_ONLINE: "Soạn thảo",
    PDF_ONLINE: "Pdf online",
    DA_TRA_LAI: "Đã trả lại",
    QUAN_LY_DOI_SO: "Quản lý đổi số",
    BI_TRA_LAI: "Bị trả lại",
    OCR: "OCR",
  },
  VAN_BAN_DEN: {
    NAME: "Văn bản đến",
    TAO_PAKN: "Tạo phản ánh kiến nghị",
    VT_THU: "Danh sách văn bản đến",
    TAO_MOI: "Vào sổ văn bản đến",
    TRA_CUU: "Tra cứu",
    CHO_VAO_SO: "Chờ vào sổ",
    CHO_PHAN_XU_LY: "Chờ phân xử lý",
    CHO_XU_LY: "Chờ xử lý",
    DANG_XU_LY: "Đang xử lý",
    DA_XU_LY: "Đã xử lý",
    BI_TRA_LAI: "Bị trả lại",
    CHO_Y_KIEN: "Chờ cho ý kiến",
    DA_CHO_Y_KIEN: "Đã cho ý kiến",
    NHAN_DE_BIET: "Nhận để biết",
    SUA: "Sửa văn bản đến",
    SAO_CHEP: "Sao chép văn bản đến",
    CHI_TIET: "Chi tiết văn bản đến",
    THU_HOI: "Bị thu hồi",
    TRA_LAI: "Đã trả lại",
    YEU_CAU_THU_HOI: "Yêu cầu thu hồi",
    BAO_CAO_LANH_DAO: "Báo cáo lãnh đạo",
    WORD_ONLINE: "Soạn thảo",
    PDF_ONLINE: "Pdf online",
    OCR: "OCR",
    YEU_CAU_CAP_NHAT: "Yêu cầu cập nhật"
  },
  HO_SO_CONG_VIEC: {
    NAME: "Hồ sơ CV",
    TRA_CUU: "Tra cứu",
    CHO_PHAN_XU_LY: "Chờ duyệt và phân xử lý",
    CHO_XU_LY: "Chờ xử lý",
    DANG_THUC_HIEN: "Đang xử lý",
    DA_KET_THUC: "Đã kết thúc",
    DA_TRA_LAI: "Đã trả lại",
    BI_TRA_LAI: "Bị trả lại",
    DA_BI_THU_HOI: "Bị thu hồi",
    CHO_CHO_Y_KIEN: "Chờ cho ý kiến",
    DA_CHO_Y_KIEN: "Đã cho ý kiến",
    THEM_MOI: "Thêm mới hồ sơ công việc",
    XEM: "Xem hồ sơ công việc",
    SUA: "Sửa hồ sơ công việc",
    WORD_ONLINE: "Soạn thảo",
    PDF_ONLINE: "Pdf online",
  },
  HE_THONG: "Hệ thống",
  TRA_CUU: "Tra cứu văn bản",
  BAO_CAO: {
    NAME: "Báo cáo",
    VAN_BAN_DI: "Văn bản đi",
    VAN_BAN_DEN: "Văn bản đến",
    VAN_BAN_TONG_HOP: "Báo cáo chung",
    NHIEM_VU: "Báo cáo nhiệm vụ",
    SO_LUONG_VAN_BAN_DEN: "Thống kê văn bản đến",
  },
  NHIEM_VU: {
    NAME: "Nhiệm vụ",
    TAO: "Thêm mới Nhiệm vụ",
    CHI_TIET: "Chi tiết Nhiệm vụ",
    CAP_NHAT: "Sửa Nhiệm vụ",
    DANH_SACH: "Danh sách Nhiệm vụ",
    IMPORT: "Nhập dữ liệu Nhiệm vụ",
    CA_NHAN: "Nhiệm vụ cá nhân",
    DON_VI: "Tra cứu",
    DON_VI_GIAO: "Nhiệm vụ đơn vị",
    CP_GIAO: "Nhiệm vụ CP/TTCP giao",
    BO_GIAO: "Nhiệm vụ Bộ giao",
  },
  LUU_TRU_DIEN_TU: {
    NAME: "Lưu trữ ĐT",
  },
  CONG_VIEC: {
    NAME: "Công việc",
  },
  VAN_BAN: {
    NAME: "Văn bản",
    DANH_SACH: "Danh sách",
    CHI_TIET: "Chi tiết",
    TAO: "Tạo",
  },
  CHUC_VU: {
    NAME: "Quản Lý Nhóm Chức Vụ",
    DANH_SACH: "Nhóm Chức Vụ",
    TAO: "Thêm Mới Nhóm Chức Vụ",
    CAP_NHAT: "Cập nhật",
    CHI_TIET: "Chi tiết",
  },
  HO_SO_LUU_TRU: {
    NAME: "Hồ sơ LT",
    DANH_MUC_HO_SO: {
      NAME: "Danh mục hồ sơ",
      THEM_MOI: "Thêm mới danh mục hồ sơ",
      SUA: "Sửa danh mục hồ sơ",
      CHI_TIET: "Xem chi tiết danh mục hồ sơ",
    },
    TINH_HINH_NOP_DANH_MUC: {
      NAME: "Tình hình nộp danh mục",
      THEM_MOI: "Thêm mới hình nộp danh mục",
    },
    HO_SO: "Hồ sơ",
    LAP_HO_SO: {
      NAME: "lap-ho-so",
      THEM_MOI: "Lập hồ sơ",
      SUA: "Sửa hồ sơ",
      THEM_TAI_LIEU: {
        NAME: "upload-tai-lieu",
        THEM_MOI: "them-tai-lieu",
      },
    },
    THU_THAP_TAI_LIEU: {
      NAME: "Thu thập tài liệu",
      YC_NOP_LUU_TAI_LIEU: "Yêu cầu nộp lưu tài liệu",
      YC_GIU_LAI_TAI_LIEU: "Yêu cầu giữ lại tài liệu",
      MUC_LUC_HO_SO: {
        NAME: "Mục lục hồ sơ, tài liệu",
        CHUA_TIEP_NHAN: "Chưa tiếp nhận",
        DA_TIEP_NHAN: "Đã tiếp nhận",
      },
      BIEN_BAN_BAN_GIAO_TAI_LIEU: "Biên bản bàn giao tài liệu",
      HO_SO_VE_VIEC_THU_THAP_TAI_LIEU: "Hồ sơ về việc thu thập tài liệu",
      HO_SO_TAI_LIEU_DA_THU_THAP: "Hồ sơ, tài liệu đã thu thập",
    },
    KHAI_THAC_SU_DUNG_TAI_LIEU: "Khai thác, sử dụng tài liệu",
    NOP_LUU_TAI_LIEU: "Nộp lưu tài liệu",
    HUY_TAI_LIEU_HET_GIA_TRI: "Hủy tài liệu hết giá trị",
    BAO_CAO: "Báo cáo",
  },
  DON_VI: {
    NAME: "Quản Lý Đơn Vị",
    DANH_SACH: "Danh Sách Đơn Vị",
    TAO: "Thêm Mới Đơn Vị",
    CAP_NHAT: "Cập nhật",
    CHI_TIET: "Chi tiết",
  },
  QUAN_TRI_HE_THONG: {
    NAME: "Quản trị HT",
    QUAN_LY_TEMPLATE: "Quản lý template",
    VAN_BAN_ERROR: "Văn bản đi ban hành lỗi",
    QUAN_LY_LOG_HE_THONG: "Quản lý log hệ thống",
    QUAN_LY_DANH_MUC_CRUD: "Quản lý danh mục",
    QUAN_LY_LOAI_VAN_BAN: "Quản lý loại văn bản",
    QUAN_LY_LOAI_SO_VAN_BAN: "Quản lý loại sổ văn bản",
    QUAN_LY_SO_VAN_BAN: "Quản lý sổ văn bản",
    QUAN_LY_DON_VI_NGOAI: "Quản lý đơn vị ngoài",
    QUAN_LY_NHOM_CONG_VIEC: "Quản lý nhóm đơn vị/ cá nhân",
    QUAN_LY_NHOM_LAM_VIEC: "Quản lý nhóm làm việc",
    QUAN_LY_DE_MUC: "Quản lý đề mục",
    QUAN_LY_LINH_VUC: "Quản lý lĩnh vực",
    QUAN_LY_UY_QUYEN: "Quản lý ủy quyền",
    CAU_HINH_UY_QUYEN: "Cấu hình ủy quyền",
    QUAN_LY_MAU_DU_THAO: {
      DANH_SACH: "Quản lý mẫu dự thảo",
      XEM: "Xem mẫu dự thảo",
      TAO: "Tạo mới mẫu dự thảo",
      SUA: "Sửa mẫu dự thảo",
    },
    CAU_HINH_HE_THONG: "Cấu hình hệ thống",
    QUAN_LY_DON_VI_NOP_LUU: "Quản lý đơn vị nộp lưu",
  },
  SCAN_VAN_BAN: "Quét dữ liệu văn bản",
  THONG_KE: "Thống kê",
};

export const PERMISSION_NAME_HSLT = {
  HSLT_THEM_MOI_LINH_VUC: "hslt-them-moi-de-muc",
  HSLT_QUAN_LY_DE_MUC_LINH_VUC: "hslt-quan-ly-de-muc-linh-vuc",
  HSLT_SUA_DE_MUC_LINH_VUC: "hslt-sua-de-muc-linh-vuc",
  HSLT_XOA_LINH_VUC: "hslt-xoa-linh-vuc",
  HSLT_QUAN_LY_DANH_MUC_HO_SO: "hslt-quan-ly-danh-muc-ho-so",
  HSLT_TONG_HOP_DANH_MUC_HO_SO: "hslt-tong-hop-danh-muc-ho-so",
  HSLT_CAP_NHAT_DANH_MUC_HO_SO: "hslt-cap-nhat-danh-muc-ho-so",
  HSLT_TRINH_DANH_MUC_HO_SO: "hslt-trinh-danh-muc-ho-so",
  HSLT_XU_LY_DANH_MUC_HO_SO: "hslt-xu-ly-danh-muc-ho-so",
  HSLT_YC_NOP_DANH_MUC_HO_SO: "hslt-yeu-cau-nop-danh-muc-ho-so",
  HSLT_QUAN_LY_DON_VI_NOP_LUU: "hslt-quan-ly-don-vi-nop-luu",
  HSLT_NOP_LUU_HO_SO: "hslt-nop-luu-ho-so",
  HSLT_XU_LY_YEU_CAU_GIU_LAI_TAI_LIEU: "hslt-xu-ly-yeu-cau-giu-lai-tai-lieu",
  HSLT_PHAN_CONG_THU_THAP_TAI_LIEU: "hslt-phan-cong-thu-thap-tai-lieu",
  HSLT_QL_TINH_HINH_GIAO_NOP_TAI_LIEU_DON_VI:
    "hslt-quan-ly-tinh-hinh-giao-nop-tai-lieu-cua-don-vi",
  HSLT_QL_TAI_LIEU_VIEC_THU_THAP_TAI_LIEU:
    "hslt-quan-ly-tai-lieu-ve-viec-thu-thap-tai-lieu",
  HSLT_XUAT_FILE: "hslt-xuat-file",
  HSLT_XU_LY_YEU_CAU_SU_DUNG_TAI_LIEU: "hslt-xu-ly-yeu-cau-su-dung-tai-lieu",
};
export const GIA_TRI_MENU_ITEM = {
  VAN_BAN_DEN: 1,
  VAN_BAN_DI: 2,
  HO_SO_CONG_VIEC: 3,
  NHIEM_VU: 4,
  BAO_CAO: 5,
  HE_THONG: 6,
  SCAN_VAN_BAN: 7,
};

export const Y_KIEN_XU_LY = {
  CHO_Y_KIEN: "Ý kiến",
  THU_HOI: "Thu hồi",
  TRA_LAI: "Trả lại",
  CAP_NHAT: "Cập nhật tình hình",
  DON_DOC: "Đôn đốc",
};

export const FORMAT_DATE_RANGE_PICKER = "MM/DD/YYYY";

export const FORMAT_DATE_RANGE_PICKER_VN = "DD/MM/YYYY";

export const FORMAT_TIME_PICKER = "DD/MM/YYYY HH:mm:ss";

export const FORMAT_DATE_REQUEST = "YYYY-MM-DD";

export const DEFAULT_TIME_START = "00:00:00";

export const DEFAULT_TIME_FINISH = "23:59:59";

export const LOCALE_VI = {
  firstDayOfWeek: 1,
  dayNames: [
    "Chủ Nhật",
    "Thứ Hai",
    "Thứ Ba",
    "Thứ Tư",
    "Thứ Năm",
    "Thứ Sáu",
    "Thứ Bảy",
  ],
  dayNamesShort: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  dayNamesMin: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  monthNames: [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12",
  ],
  monthNamesShort: [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12",
  ],
  today: "Hôm nay",
  clear: "Xóa bỏ",
  weekHeader: "Tuần đầu",
};

export const GIA_TRI_HAN_XU_LY = {
  TAT_CA: 0,
  QUA_HAN_XU_LY: 1,
  HAN_XU_LY_CON_KHONG_QUA_HAI_NGAY: 2,
  HAN_XU_LY_CON_NHIEU_HON_HAI_NGAY: 3,
  DA_XU_LY: 5,
  KHONG_PHAI_XU_LY: 6,
};

export const GIA_TRI_TRANG_THAI_VAN_BAN_DEN = {
  TAT_CA: "TAT_CA",
  CHO_VAO_SO: "CHO_VAO_SO",
  CHO_PHAN_XU_LY: "CHO_PHAN_XU_LY",
  CHO_XU_LY: "CHO_XU_LY",
  DANG_XU_LY: "DANG_XU_LY",
  DA_XU_LY: "DA_XU_LY",
  DA_TRA_LAI: "TRA_LAI",
  THU_HOI: "THU_HOI",
  NHAN_DE_BIET: "NHAN_DE_BIET",
  YEU_CAU_THU_HOI: "YEU_CAU_THU_HOI",
  HUY: "HUY",
  OCR: "OCR",
};
export const GIA_TRI_TRANG_THAI_VAN_BAN_DI = {
  CHO_TRINH_KY: "CHO_TRINH_KY",
  CHO_XU_LY: "CHO_XU_LY",
  DA_XU_LY: "DA_XU_LY",
  DA_TRA_LAI: "DA_TRA_LAI",
  CHO_Y_KIEN: "CHO_Y_KIEN",
  DA_CHO_Y_KIEN: "DA_CHO_Y_KIEN",
  QUAN_LY_DOI_SO: "QUAN_LY_DOI_SO",
  QUAN_LY_GIU_SO: "QUAN_LY_GIU_SO",
  CHO_CAP_SO: "CHO_CAP_SO",
  CHO_BAN_HANH: "CHO_BAN_HANH",
  DA_BAN_HANH: "DA_BAN_HANH",
  NOI_BO: "NOI_BO",
  OCR: "OCR",
};

export const SO_LUONG_VAN_BAN_DEN = {
  CHO_VAO_SO: "SoLuongChoVaoSo",
  BAO_CAO_LANH_DAO: "BaoCaoLanhDao",
  CHO_PHAN_XU_LY: "SoLuongChoPhanXuLy",
  CHO_XU_LY: "SoLuongChoXuLy",
  DANG_XU_LY: "SoLuongDangXuLy",
  DA_XU_LY: "SoLuongDaXuLy",
  BI_TRA_LAI: "SoLuongBiTraLai",
  TRA_LAI: "SoLuongTraLai",
  DA_TRA_LAI: "SoLuongDaTraLai",
  THU_HOI: "SoLuongThuHoi",
  NHAN_DE_BIET: "SoLuongNhanDeBiet",
  CHO_Y_KIEN: "SoLuongChoYKien",
  DA_CHO_Y_KIEN: "SoLuongDaChoYKien",
  YEU_CAU_THU_HOI: "SoLuongYeuCauThuHoi",
  OCR: "SoLuongOCR",
  YEU_CAU_CAP_NHAT: "YeuCauCapNhat",
};

export const GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH = {
  TAT_CA: "TAT_CA",
  CHO_VAO_SO: "CHO_VAO_SO",
  CHO_VAO_SO_DIEN_TU: "CHO_VAO_SO_DIEN_TU",
  CHO_PHAN_XU_LY: "CHO_PHAN_XU_LY",
  CHO_XU_LY: "CHO_XU_LY",
  DANG_XU_LY: "DANG_XU_LY",
  DA_XU_LY: "DA_XU_LY",
  TRA_LAI: "TRA_LAI",
  DA_TRA_LAI: "DA_TRA_LAI",
  THU_HOI: "THU_HOI",
  NHAN_DE_BIET: "NHAN_DE_BIET",
  HUY: "HUY",
  YEU_CAU_THU_HOI: "YEU_CAU_THU_HOI",
};

export const MANG_GIA_TRI_TRANG_THAI_VAN_BAN_DEN = [
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.TAT_CA,
    text: "Tất cả",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.CHO_VAO_SO,
    text: "Chờ vào sổ",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.CHO_PHAN_XU_LY,
    text: "Chờ phân xử lý",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.CHO_XU_LY,
    text: "Chờ xử lý",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.DANG_XU_LY,
    text: "Đang xử lý",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.DA_XU_LY,
    text: "Đã xử lý",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.TRA_LAI,
    text: "Trả lại",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.DA_TRA_LAI,
    text: "Đã trả lại",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.THU_HOI,
    text: "Thu hồi",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.NHAN_DE_BIET,
    text: "Nhận để biết",
  },
  {
    value: GIA_TRI_TRANG_THAI_VAN_BAN_DEN_DANH_SACH.YEU_CAU_THU_HOI,
    text: "Yêu cầu thu hồi",
  },
];

export const GIA_TRI_LOAI_BAO_CAO = {
  SO_LUONG: "NGHI_QUYET_17_VAN_BAN_DEN",
  TONG_HOP: "TONG_HOP",
  CHI_TIET: "CHI_TIET",
  SO_VAN_BAN: "SO_VAN_BAN",
  HINH_THUC: "HINH_THUC",
  TRANG_THAI: "TRANG_THAI",
  QUA_HAN: "QUA_HAN",
};
export const DANH_SACH_LOAI_BAO_CAO = [
  {
    value: GIA_TRI_LOAI_BAO_CAO.SO_VAN_BAN,
    text: "Báo cáo theo sổ văn bản",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO.HINH_THUC,
    text: "Báo cáo theo phương thức nhận văn bản",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO.TRANG_THAI,
    text: "Báo cáo theo trạng thái",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO.SO_LUONG,
    text: "Báo cáo văn bản đến theo nghị quyết 17",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO.QUA_HAN,
    text: "Báo cáo văn bản quá hạn",
  },
];

export const GIA_TRI_LOAI_BAO_CAO_VAN_BAN_DI = {
  SO_LUONG_CAP_SO: "SO_LUONG_THEO_LOAI_HINH_CAP_SO",
  SO_LUONG_VB_DI: "NGHI_QUYET_17_VAN_BAN_DI",
  IN_SO: "SO_VAN_BAN_DI",
  SO_LUONG: "SO_LUONG",
  CHI_TIET: "CHI_TIET_VAN_BAN_DI",
  THONG_KE: "SO_LUONG_VAN_BAN_DI_DIEN_TU",
};

export const DANH_SACH_LOAI_BAO_CAO_VAN_BAN_DI = [
  {
    value: GIA_TRI_LOAI_BAO_CAO_VAN_BAN_DI.SO_LUONG_VB_DI,
    text: "Báo cáo văn bản đi theo nghị quyết 17",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO_VAN_BAN_DI.SO_LUONG_CAP_SO,
    text: "Báo cáo thống kê số lượng theo loại hình cấp số",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO_VAN_BAN_DI.IN_SO,
    text: "Báo cáo in sổ văn bản đi",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO_VAN_BAN_DI.SO_LUONG,
    text: "Báo cáo số lượng văn bản đi",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO_VAN_BAN_DI.CHI_TIET,
    text: "Báo cáo chi tiết văn bản đi",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO_VAN_BAN_DI.THONG_KE,
    text: "Báo cáo thống kê số lượng phát hành văn bản đi điện tử",
  },
];

export const GIA_TRI_LOAI_BAO_CAO_CHUNG = {
  VAN_BAN_GUI: "VAN_BAN_GUI",
  DON_VI_XU_LY: "DON_VI_XU_LY",
  CD_SO: "CD_SO",
};
export const DANH_SACH_LOAI_BAO_CAO_CHUNG = [
  {
    value: GIA_TRI_LOAI_BAO_CAO_CHUNG.VAN_BAN_GUI,
    text: "Báo cáo số lượng văn bản gửi, nhận điện tử số lượng văn bản gửi, đi nhận điện tử",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO_CHUNG.DON_VI_XU_LY,
    text: "Báo cáo số lượng đơn vị xử lý văn bản và hồ sơ công việc trên môi trường mạng",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO_CHUNG.CD_SO,
    text: "Báo cáo đánh giá mức độ chuyển đổi số của các đơn vị trong bộ",
  },
];

export const DANH_SACH_KI_BAO_CAO = [
  {
    value: "NGAY",
    text: "Báo cáo từ ngày đến ngày",
  },
  {
    value: "THANG",
    text: "Báo cáo theo Tháng",
  },
  {
    value: "6THANG",
    text: "Báo cáo theo 6 Tháng",
  },
  {
    value: "QUY",
    text: "Báo cáo theo Quý",
  },
  {
    value: "NAM",
    text: "Báo cáo theo Năm",
  },
];

export const DANH_SACH_KI_BAO_CAO_CDSO = [
  {
    value: "THANG",
    text: "Báo cáo theo Tháng",
  },
  {
    value: "6THANG",
    text: "Báo cáo theo 6 Tháng",
  },
  {
    value: "QUY",
    text: "Báo cáo theo Quý",
  },
  {
    value: "NAM",
    text: "Báo cáo theo Năm",
  },
];

export const MANG_HAN_XU_LY = [
  {
    value: GIA_TRI_HAN_XU_LY.TAT_CA,
    text: "Tất cả",
    color: "#000000",
  },
  {
    value: GIA_TRI_HAN_XU_LY.QUA_HAN_XU_LY,
    text: "Quá hạn",
    color: "#ea0e0e",
  },
  {
    value: GIA_TRI_HAN_XU_LY.HAN_XU_LY_CON_KHONG_QUA_HAI_NGAY,
    text: "Đến hạn",
    color: "#0046ff",
  },
  {
    value: GIA_TRI_HAN_XU_LY.HAN_XU_LY_CON_NHIEU_HON_HAI_NGAY,
    text: "Trong hạn",
    color: "#000000",
  },
  {
    value: GIA_TRI_HAN_XU_LY.DA_XU_LY,
    text: "Đã xử lý",
    color: "#000000",
  },
  {
    value: GIA_TRI_HAN_XU_LY.KHONG_PHAI_XU_LY,
    text: "Không phải xử lý",
    color: "#000000",
  },
];

export const MANG_HAN_XU_LY_CONG_VIEC = [
  {
    value: 1,
    text: "Quá hạn",
    color: "#ff0000",
  },
  {
    value: 2,
    text: "Trong hạn",
    color: "#0000ff",
  },
  {
    value: 3,
    text: "Quan trọng",
    color: "#800080",
  },
];

export const GIA_TRI_THAO_TAC_TIM_KIEM_NHIEM_VU = {
  TAT_CA: 0,
  CHUA_THUC_HIEN: 1,
  DANG_THUC_HIEN: 2,
  DA_HOAN_THANH: 3,
  CHUA_PHAN_XU_LY: 5,
  DEN_HAN_XU_LY: 6,
  TRA_LAI: 7,
  THU_HOI: 8,
};

export const BANG_DANH_SACH_NHIEM_VU = {
  SoNhiemVu: "Số nhiệm vụ",
  NoiDungTheoDoi: "Nội dung theo dõi",
  TinhHinhThucHienNoiBo: "Tình hình thực hiện",
  HanXuLy: "Hạn xử lý",
  SoNgayConQuaHan: "Số ngày còn/ quá hạn",
  DonDocNhiemVu: "Đôn đốc nhiệm vụ",
  ChuyenVienTheoDoi: "Chuyên viên theo dõi",
  HanXuLyVpcp: "Hạn xử lý VPCP",
  SoKyHieuVanBan: "Số/Ký hiệu văn bản",
  NgayVanBan: "Ngày văn bản",
  LoaiNhiemVu: "Loại nhiệm vụ",
  thaoTac: "Thao tác",
  ChuTri: "Chủ trì",
  PhoiHop: "Phối hợp",
};

export const DANH_SACH_TRA_LAI_NHIEM_VU_CHINH_PHU = [
  {
    key: "SoNhiemVu",
    label: "Số nhiệm vụ",
    tdClass: "text-left",
    thClass: "w-30",
  },
  {
    key: "NoiDungTheoDoi",
    label: "Nội dung theo dõi",
    tdClass: "text-left",
    thClass: "w-40",
  },
  {
    key: "SoKyHieuVanBan",
    label: "Số/Ký hiệu văn bản",
    tdClass: "text-left",
    thClass: "w-15",
  },
  {
    key: "NgayVanBan",
    label: "Ngày văn bản",
    thClass: "w-15",
  },
];

export const DANH_SACH_BAO_CAO_TONG_HOP = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "DonViBanHanh",
    label: "Đơn vị ban hành",
  },
  {
    key: "SoLuongVanBan",
    label: "Số lượng văn bản",
  },
];
export const DANH_SACH_BAO_CAO_TONG_HOP_EXPORT = {
  Stt: "",
  DonViBanHanh: "",
  SoLuongVanBan: "",
};

export const DANH_SACH_BAO_CAO_QUA_HAN = [
  {
    key: "Stt",
    label: "STT",
    thClass: "w-5",
  },
  {
    key: "TenDonVi",
    label: "Đơn vị/ cá nhân",
  },
  {
    key: "TongSo",
    label: "Tổng số",
  },
];

export const DANH_SACH_CHI_TIET_BAO_CAO_QUA_HAN = [
  {
    key: "Stt",
    label: "STT",
    thClass: "w-5",
  },
  {
    key: "NoiGui",
    label: "Tên cơ quan",
    thClass: "w-20",
  },
  {
    key: "SoDen",
    label: "Số đến",
    thClass: "w-7",
  },
  {
    key: "SoKyHieu",
    label: "Số/Ký hiệu",
    thClass: "w-10",
  },
  {
    key: "TrichYeu",
    label: "Trích yếu",
    thClass: "w-20",
  },
  {
    key: "NgayDen",
    label: "Ngày đến",
    thClass: "w-10",
  },
  {
    key: "HanXuLy",
    label: "Hạn xử lý",
    thClass: "w-10",
  },
  {
    key: "ChuTri",
    label: "Chủ trì",
    thClass: "w-10",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
    thClass: "w-15",
  },
];

export const DANH_SACH_BAO_CAO_CHI_TIET = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "NgayVanBan",
    label: "Ngày đến",
  },
  {
    key: "SoKyHieu",
    label: "Số/Ký hiệu",
  },
  {
    key: "TrichYeu",
    label: "Trích yếu",
  },
  {
    key: "DonViBanHanh",
    label: "Đơn vị ban hành",
  },
  {
    key: "DonViNhan",
    label: "Đơn vị nhận",
  },
  {
    key: "LoaiVanBan",
    label: "Loại văn bản",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
  },
];
export const DANH_SACH_BAO_CAO_CHI_TIET_EXPORT = {
  Stt: "",
  NgayVanBan: "",
  SoKyHieu: "",
  TrichYeu: "",
  DonViBanHanh: "",
  DonViNhan: "",
  LoaiVanBan: "",
  TrangThai: "",
};

export const DANH_SACH_BAO_CAO_SO_LUONG_VB_DI_EXPORT = {
  Stt: "",
  DonVi: "",
  TongSoVanBanDaBanHanh: "",
  TongSoVanBanCoLuong: "",
  TongSoVanBanCoKySoVanBan: "",
  TongSoGuiDonViNoiBo: "",
  TongSoGuiDonViNgoai: "",
};

export const DANH_SACH_BAO_CAO_SO_LUONG_CAP_SO_EXPORT = {
  Stt: "",
  TenDonVi: "",
  TongSoVanBanDaBanHanh: "",
  SoLuongCapSoGiay: "",
  SoLuongCapSoDienTu: "",
};
export const DANH_SACH_BAO_CAO_SO_VAN_BAN = [
  {
    key: "Stt",
    label: "STT",
    thClass: "w-2",
  },

  {
    key: "NgayDen",
    label: "Ngày đến",
    thClass: "w-5",
  },
  {
    key: "SoDen",
    label: "Số đến",
    thClass: "w-5",
  },
  {
    key: "NoiGui",
    label: "Tác giả",
    thClass: "w-15",
  },
  {
    key: "SoKyHieu",
    label: "Số/Ký hiệu văn bản",
    thClass: "w-10",
  },
  {
    key: "NgayVanBan",
    label: "Ngày tháng văn bản",
    thClass: "w-5",
  },
  {
    key: "TrichYeuLoaiVanBan",
    label: "Tên loại và trích yếu nội dung văn bản",
    thClass: "w-20",
  },
  {
    key: "NoiNhan",
    label: "Đơn vị hoặc người nhận",
    thClass: "w-10",
    tdClass: "text-left",
  },
  {
    key: "NgayChuyen",
    label: "Ngày chuyển",
    thClass: "w-5",
  },
  {
    key: "KyNhan",
    label: "Ký nhận",
    thClass: "w-5",
  },
  {
    key: "GhiChu",
    label: "Ghi chú",
    thClass: "w-10",
  },
];

export const DANH_SACH_BAO_CAO_SO_VAN_BAN_EXPORT = {
  Stt: "",
  SoKyHieu: "",
  NgayVanBan: "",
  TrichYeu: "",
  NguoiKy: "",
  NoiNhanVanBan: "",
  LoaiVanBan: "",
  TrangThai: "",
};

export const DANH_SACH_BAO_CAO_TRANG_THAI = [
  {
    key: "Stt",
    label: "STT",
    thClass: "w-5",
  },
  { key: "DonViNhan", label: "Tên đơn vị/cá nhân nhận", thClass: "w-20" },
  { key: "TongSo", label: "Tổng số", thClass: "w-15" },
  { key: "SoLuongChoVaoSo", label: "Chờ vào sổ", thClass: "w-15" },
  { key: "SoLuongChoXuLy", label: "Chờ xử lý", thClass: "w-15" },
  { key: "SoLuongDangXuLy", label: "Đang xử lý", thClass: "w-15" },
  { key: "SoLuongDaXuLy", label: "Đã xử lý", thClass: "w-15" },
];

export const DANH_SACH_SO_LUONG_VB_DEN = [
  {
    key: "Stt",
    label: "STT",
    thClass: "w-2",
  },
  {
    key: "TenDonVi",
    label: "Đơn vị",
  },
  {
    key: "SoLuong",
    label: "Số lượng",
  },
];

export const DANH_SACH_BAO_CAO_HINH_THUC = [
  {
    key: "Stt",
    label: "STT",
    thClass: "w-2",
  },
  {
    key: "DonViNhan",
    label: "Đơn vị/Cá nhân nhận",
    thClass: "w-20",
  },
  {
    key: "TongSo",
    label: "Tổng số",
    thClass: "w-15",
  },
  {
    key: "SoLuongBanGiay",
    label: "Phương thức nhận bản giấy",
    thClass: "w-10",
  },
  {
    key: "SoLuongDienTu",
    label: "Phương thức nhận điện tử",
    thClass: "w-10",
  },
  {
    key: "SoLuongBanGiayVaDienTu",
    label: "Phương thức nhận bản giấy và điện tử",
    thClass: "w-10",
  },
];

export const DANH_SACH_BAO_CAO_TRANG_THAI_EXPORT = {
  Stt: "",
  DonViNhan: "",
  TongSo: "",
  SoLuongChoVaoSo: "",
  SoLuongChoXuLy: "",
  SoLuongDangXuLy: "",
  SoLuongDaXuLy: "",
};

export const DANH_SACH_BAO_CAO_HINH_THUC_EXPORT = {
  Stt: "",
  DonViNhan: "",
  NgayVanBan: "",
  TrichYeu: "",
  NguoiKy: "",
  NoiNhanVanBan: "",
  LoaiVanBan: "",
  TrangThai: "",
};

export const DANH_SACH_SO_LUONG_VB_DEN_EXPORT = {
  Stt: "",
  DonVi: "",
  SoLuong: "",
};

export const MA_LOAI_NHIEM_VU = {
  NHIEM_VU_CHINH_PHU: "NVCP",
  NHIEM_VU_BO: "NVB",
  NHIEM_VU_DON_VI: "NVDV",
};

export const GIA_TRI_LOAI_NHIEM_VU = {
  NHIEM_VU_CP_VPCP: 1,
  NHIEM_VU_BO: 2,
  NHIEM_VU_DON_VI: 3,
};

export const LOAI_NHIEM_VU = [
  {
    value: GIA_TRI_LOAI_NHIEM_VU.NHIEM_VU_CP_VPCP,
    text: "CP/VPCP",
  },
  {
    value: GIA_TRI_LOAI_NHIEM_VU.NHIEM_VU_BO,
    text: "Bộ trưởng",
  },
  {
    value: GIA_TRI_LOAI_NHIEM_VU.NHIEM_VU_DON_VI,
    text: "Đơn vị",
  },
];
export const GIA_TRI_DON_VI_LAP_ID = {
  TRUNG_TAM_TIN_HOC: 5,
};

export const DON_VI_LAP_ID = [
  {
    value: GIA_TRI_DON_VI_LAP_ID.TRUNG_TAM_TIN_HOC,
    text: "Trung tâm tin học",
  },
];

export const GIA_TRI_TINH_HINH_THUC_HIEN = {
  CHUA_THUC_HIEN: 1,
  DANG_THUC_HIEN: 2,
  DA_HOAN_THANH: 3,
};

export const TINH_HINH_THUC_HIEN = [
  {
    value: GIA_TRI_TINH_HINH_THUC_HIEN.CHUA_THUC_HIEN,
    text: "Chưa thực hiện",
  },
  {
    value: GIA_TRI_TINH_HINH_THUC_HIEN.DANG_THUC_HIEN,
    text: "Đang thực hiện",
  },
  {
    value: GIA_TRI_TINH_HINH_THUC_HIEN.DA_HOAN_THANH,
    text: "Đã hoàn thành",
  },
];

export const PERMISSION_NAME = {
  CAP_NHAT_NHIEM_VU: "cap-nhat-nhiem-vu",
  CAU_HINH_UY_QUYEN: "cau-hinh-uy-quyen",
  QUAN_LY_UY_QUYEN: "quan-ly-uy-quyen",
  CAP_NHAT_NHIEM_VU_BO: "cap-nhat-nhiem-vu-bo",
  CAP_NHAT_NHIEM_VU_CHINH_PHU: "cap-nhat-nhiem-vu-chinh-phu",
  CAP_NHAT_NHIEM_VU_DON_VI: "cap-nhat-nhiem-vu-don-vi",
  CAP_NHAT_TINH_HINH_THUC_HIEN: "cap-nhat-tinh-hinh-thuc-hien",
  DANH_SACH_NHIEM_VU: "danh-sach-nhiem-vu",
  DANH_SACH_NHIEM_VU_TRONG_BO: "danh-sach-nhiem-vu-trong-bo",
  DANH_SACH_NHIEM_VU_TRONG_DON_VI: "danh-sach-nhiem-vu-trong-don-vi",
  DANH_SACH_NHIEM_VU_TRONG_PHONG: "danh-sach-nhiem-vu-trong-phong",
  EXPORT_NHIEM_VU: "export-nhiem-vu",
  IMPORT_NHIEM_VU: "import-nhiem-vu",
  PHAN_XU_LY: "phan-xu-ly",
  GIA_HAN_NHIEM_VU: "gia-han-nhiem-vu-cp/vpcp",
  PHA_XU_LY_NHIEM_VU_TRONG_BO: "phan-xu-ly-nhiem-vu-trong-bo",
  PHAN_XU_LY_NHIEM_VU_TRONG_DON_VI: "phan-xu-ly-nhiem-vu-trong-don-vi",
  PHAN_XU_LY_NHIEM_VU_TRONG_PHONG: "phan-xu-ly-nhiem-vu-trong-phong",
  QUAN_TRI_HE_THONG: "quan-tri-he-thong",
  THEM_MOI_NHIEM_VU: "them-moi-nhiem-vu",
  THEM_MOI_NHIEM_VU_BO: "them-moi-nhiem-vu-bo",
  THEM_MOI_NHIEM_VU_CHINH_PHU: "them-moi-nhiem-vu-chinh-phu",
  THEM_MOI_NHIEM_VU_DON_VI: "them-moi-nhiem-vu-don-vi",
  THIET_LAP_HE_THONG: "thiet-lap-he-thong",
  THU_HOI_NHIEM_VU: "thu-hoi-nhiem-vu",
  THU_HOI_NHIEM_VU_NGUOI_KHAC: "thu-hoi-nhiem-vu-nguoi-khac",
  TRA_LAI_NHIEM_VU: "tra-lai-nhiem-vu",
  TRA_LAI_NHIEM_VU_VPCP: "tra-lai-nhiem-vu-cp/vpvp",
  XEM_CHI_TIET_NHIEM_VU: "xem-chi-tiet-nhiem-vu",
  DANH_SACH_NHIEM_VU_DON_VI_GIAO: "danh-sach-nhiem-vu-don-vi-giao",
  DANH_SACH_NHIEM_VU_CP_GIAO: "danh-sach-nhiem-vu-cp-ttcp-giao",
  DANH_SACH_NHIEM_VU_BO_GIAO: "danh-sach-nhiem-vu-bo-giao",
  // Văn bản đi
  TAO_VAN_BAN_TRINH_KY: "van-ban-di-tao-van-ban-trinh-ky",
  LUU_LUONG_TRINH_KY: "van-ban-di-luu-luong-trinh-ky",
  XOA_LUONG_TRINH_KY: "van-ban-di-xoa-luong-trinh-ky",
  SUA_VAN_BAN_TRINH_KY: "van-ban-di-sua-van-ban-trinh-ky",
  XOA_VAN_BAN_TRINH_KY: "van-ban-di-xoa-van-ban-trinh-ky",
  TRINH_XU_LY_VAN_BAN: "van-ban-di-trinh-xu-ly-van-ban",
  SAO_CHEP_VAN_BAN_TRINH_KY: "van-ban-di-sao-chep",
  KY_DUYET_VAN_BAN_DI: "van-ban-di-ky-duyet",
  TRA_LAI_VAN_BAN_DI: "van-ban-di-tra-lai",
  XIN_Y_KIEN_VAN_BAN_DI: "van-ban-di-xin-y-kien",
  XEM_LUONG_VAN_BAN_DI: "van-ban-di-xem-luong",
  THEO_DOI_VAN_BAN_DI: "van-ban-di-theo-doi",
  TRINH_KY_VAN_BAN_DI: "van-ban-di-trinh-ky",
  HUY_TRINH_KY_VAN_BAN_DI: "van-ban-di-huy-trinh-ky",
  HUY_DUYET_VAN_BAN_DI: "van-ban-di-huy-duyet",
  CHO_CHO_Y_KIEN_VAN_BAN_DI: "van-ban-di-cho-cho-y-kien",
  DA_CHO_Y_KIEN_VAN_BAN_DI: "van-ban-di-da-cho-y-kien",
  TRA_CUU_VAN_BAN: "van-ban-di-tra-cuu-van-ban",
  KIEM_TRA_THE_THUC: "van-ban-di-kiem-tra-the-thuc",
  CAP_SO: "van-ban-di-cap-so",
  BAN_HANH: "van-ban-di-ban-hanh",
  BAN_HANH_BO_SUNG: "van-ban-di-ban-hanh-bo-xung",
  SUA_VAN_BAN_CHO_CAP_SO: "van-ban-di-sua-van-ban-cho-cap-so",
  SUA_VAN_BAN_CHO_BO_CAP_SO: "van-ban-di-sua-van-ban-cho-bo-cap-so",
  SUA_VAN_BAN_CHO_BAN_HANH: "van-ban-di-sua-van-ban-cho-ban-hanh",
  SUA_VAN_BAN_DA_BAN_HANH: "van-ban-di-sua-van-ban-da-ban-hanh",
  THEM_VAN_BAN_DA_BAN_HANH: "van-ban-di-them-van-ban-da-ban-hanh",
  THU_HOI_VAN_BAN_DA_BAN_HANH: "van-ban-di-thu-hoi-van-ban-da-ban-hanh",
  DA_BAN_HANH: "van-ban-di-da-ban-hanh",
  VAN_BAN_DI_NOI_BO: "van-ban-di-van-ban-di-noi-bo",
  GIU_SO: "van-ban-di-giu-so",
  TRA_SO: "van-ban-di-tra-so",
  TRINH_KY_TIEO_THEO: "van-ban-di-trinh-ky-tiep-theo",
  CHUYEN_VUNG_DU_LIEU: "chuyen-vung-du-lieu",
  QUAN_LY_NHOM_DON_VI_CA_NHAN: "quan-ly-nhom-don-vi-ca-nhan",
  VAN_BAN_DI_QR: "van-ban-di-qr",
  QUAN_LY_MAU_DU_THAO: "quan-ly-mau-du-thao",
  VAN_BAN_DI_BAO_CAO: "van-ban-di-bao-cao",
  VAN_BAN_DI_DOI_SO: "van-ban-di-doi-so",
  XEM_DANH_SACH_VAN_BAN_DI_CA_NHAN: "xem-danh-sach-van-ban-di-cua-ca-nhan",
  VAN_BAN_DI_OCR: "van-ban-di-danh-sach-ocr",
  VAN_BAN_DEN_OCR: "van-ban-den-danh-sach-ocr",

  HO_SO_CONG_VIEC_THEM_MOI_HO_SO: "ho-so-cong-viec-them-moi-ho-so",
  HO_SO_CONG_VIEC_SUA_HO_SO: "ho-so-cong-viec-sua-ho-so",
  HO_SO_CONG_VIEC_XOA_HO_SO: "ho-so-cong-viec-xoa-ho-so",
  HO_SO_CONG_VIEC_XEM_CHI_TIET_HO_SO: "ho-so-cong-viec-xem-chi-tiet-ho-so",
  HO_SO_CONG_VIEC_CAP_NHAT_TRANG_THAI: "ho-so-cong-viec-cap-nhat-trang-thai",
  HO_SO_CONG_VIEC_PHAN_XU_LY: "ho-so-cong-viec-phan-xu-ly",
  HO_SO_CONG_VIEC_THU_HOI: "ho-so-cong-viec-thu-hoi",
  HO_SO_CONG_VIEC_TRA_LAI: "ho-so-cong-viec-tra-lai",
  HO_SO_CONG_VIEC_HUY_HOAN_THANH: "ho-so-cong-viec-huy-hoan-thanh",

  CHUYEN_VIEN: "chuyen-vien",
  VAN_THU_BO: "van-thu-bo",
  LANH_DAO_BO: "lanh-dao-bo",
  LANH_DAO_DON_VI: "lanh-dao-don-vi",
  LANH_DAO_VAN_PHONG_BO: "lanh-dao-van-phong-bo",
  LANH_DAO_THEO_DOI: "lanh-dao-theo-doi",
  VAN_THU_DON_VI: "van-thu-don-vi",

  QUAN_LY_SO_VAN_BAN: "quan-ly-so-van-ban",
  QUAN_LY_LOAI_VAN_BAN: "quan-ly-loai-van-ban",
  QUAN_LY_DON_VI_NGOAI: "quan-ly-don-vi-ngoai",

  QUAN_LY_TEMPLATE: "quan-ly-template",
  QUAN_LY_LOG_HE_THONG: "quan-ly-log-he-thong",
  QUAN_LY_DANH_MUC: "quan-ly-danh-muc",
  QUAN_LY_NHOM_LAM_VIEC: "quan-ly-nhom-lam-viec",
  QUAN_LY_DE_MUC: "quan-ly-de-muc",
  QUAN_LY_LOAI_SO_VAN_BAN: "quan-ly-loai-so-van-ban",
  CAU_HINH_HE_THONG: "cau-hinh-he-thong",
  QUAN_LY_DON_VI_NOP_LUU: "quan-ly-don-vi-nop-luu",
  SCAN_VAN_BAN: "scan-van-ban",
  TAO_PAKN: "tao-pakn",
  YEU_CAU_TRA_LAI: "van-ban-di-danh-sach-yeu-cau-tra-lai",
  BI_TRA_LAI: "van-ban-di-danh-sach-bi-tra-lai",
  XEM_VAN_BAN_LOI_BAN_HANH: "xem-van-ban-di-loi-ban-hanh",
  UNCHECK: "un-check",
  TRA_CUU_VAN_BAN_DEN: "van-ban-den-danh-sach-tra-cuu",
  CHO_VAO_SO_VAN_BAN_DEN: "van-ban-den-danh-sach-cho-vao-so",
  CHO_XU_LY_VAN_BAN_DEN: "van-ban-den-danh-sach-cho-xu-ly",
  DANG_XU_LY_VAN_BAN_DEN: "van-ban-den-danh-sach-dang-xu-ly",
  DA_XU_LY_VAN_BAN_DEN: "van-ban-den-danh-sach-da-xu-ly",
  DA_TRA_LAI_VAN_BAN_DEN: "van-ban-den-danh-sach-da-tra-lai",
  BI_THU_HOI_VAN_BAN_DEN: "van-ban-den-danh-sach-bi-thu-hoi",
  CHO_CHO_Y_KIEN_VAN_BAN_DEN: "van-ban-den-danh-sach-cho-cho-y-kien",
  DA_CHO_Y_KIEN_VAN_BAN_DEN: "van-ban-den-danh-sach-da-cho-y-kien",
  NHAN_DE_BIET_VAN_BAN_DEN: "van-ban-den-danh-sach-nhan-de-biet",
  YEU_CAU_THU_HOI_VAN_BAN_DEN: "van-ban-den-danh-sach-yeu-cau-thu-hoi",
  NHAN_BAO_CAO_LANH_DAO: "nhan-bao-cao-lanh-dao",
};

export const PERMISSION_NAME_VAN_BAN = {
  DUOC_BAO_CAO_LANH_DAO: "duoc-bao-cao-lanh-dao",
  DUOC_PHAN_DE_CHI_DAO: "duoc-phan-de-chi-dao",
  VAN_BAN_DEN_CONG_BO: "van-ban-den-cong-bo",
  VAN_BAN_DEN_XIN_Y_KIEN: "van-ban-den-xin-y-kien",
  VAN_BAN_DEN_SAO_CHEP: "van-ban-den-sao-chep",
  VAN_BAN_DEN_DONG_NHAT: "van-ban-den-dong-nhat",
  VAN_BAN_DEN_VAO_SO_VAN_BAN_GIAY: "van-ban-den-vao-so-van-ban-giay",
  VAN_BAN_DEN_SUA: "van-ban-den-sua-van-ban-vao-so",
  VAN_BAN_DEN_XOA: "van-ban-den-xoa-van-ban-vao-so",
  VAN_BAN_DEN_VAO_SO_DIEN_TU_BANG_TAY: "van-ban-den-vao-so-dien-tu-bang-tay",
  VAN_BAN_DEN_VAO_SO_TU_DONG: "vao-so-tu-dong",
  VAN_BAN_DEN_PHAN_XU_LY: "van-ban-den-phan-xu-ly",
  VAN_BAN_DEN_TAO_DU_THAO: "van-ban-den-tao-du-thao",
  VAN_BAN_DEN_BAO_CAO_LANH_DAO: "van-ban-den-bao-cao-lanh-dao",
  VAN_BAN_DEN_IMPORT: "van-ban-den-import",
  VAN_BAN_DEN_EXPORT: "van-ban-den-export",
  VAN_BAN_DEN_THU_HOI: "van-ban-den-thu-hoi",
  VAN_BAN_DEN_QR: "van-ban-den-qr",
  VAN_BAN_DEN_TRA_CUU_PHAM_VI: "van-ban-den-tra-cuu-pham-vi",
  VAN_BAN_DEN_TU_CHOI_THU_HOI: "tu-choi-thu-hoi",
  VAN_BAN_DEN_CHUYEN_VUNG: "chuyen-vung-du-lieu",
  VAN_BAN_DEN_DONG_Y_THU_HOI: "dong-y-thu-hoi",
  XEM_DANH_SACH_VAN_BAN_DEN_CA_NHAN: "xem-danh-sach-van-ban-den-cua-ca-nhan",
  VAN_BAN_DEN_OCR: "van-ban-den-danh-sach-ocr",
};

export const DANH_SACH_TRA_LAI_NHIEM_VU = {
  HO_TEN: "Họ và tên",
  DON_VI: "Đơn vị",
  CHUC_VU: "Chức vụ",
};

export const DANH_SACH_NHIEM_VU = [
  {
    key: "CheckBox",
    label: "",
  },
  {
    key: "SoNhiemVu",
    label: "Số nhiệm v",
  },
  {
    key: "NoiDungTheoDoi",
    label: "Nội dung theo dõi",
  },
  {
    key: "TinhHinhThucHienNoiBo",
    label: "Tình hình thực hiện",
  },
  {
    key: "HanXuLy",
    label: "Hạn xử lý",
  },
  {
    key: "LoaiNhiemVu",
    label: "Loại nhiệm vụ",
  },
  {
    key: "CongViec",
    label: "Công việc",
  },
  {
    key: "TrangThaiXuLy",
    label: "Trạng thái xử lý",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
  },
  {
    key: "HoatDong",
    label: "",
  },
];
export const DANH_SACH_LICH_SU_CONG_VIEC_GIAO_VIEC = [
  {
    key: "STT",
    label: "STT",
  },
  {
    key: "NguoiGiaoViec",
    label: "Người giao việc",
  },
  {
    key: "DonViGiaoViec",
    label: "Đơn vị giao việc",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
  },
  {
    key: "NguoiXuLy",
    label: "Người xử lý",
  },
  {
    key: "DonViXuLy",
    label: "Đơn vị xử lý",
  },
];
export const DANH_SACH_LICH_SU_CONG_VIEC_THAY_DOI_TRANG_THAI = [
  {
    key: "STT",
    label: "STT",
  },
  {
    key: "NguoiCapNhat",
    label: "Người cập nhật",
  },
  {
    key: "DonVi",
    label: "Đơn vị",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
  },
  {
    key: "NoiDung",
    label: "Nội dung cập nhật",
  },
  {
    key: "VanBanLienQuan",
    label: "Văn bản liên quan",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
  },
];
export const DANH_SACH_LICH_SU_CAP_NHAT_TINH_HINH = [
  {
    key: "NguoiCapNhat",
    label: "Người cập nhật",
  },
  {
    key: "DonViCapNhat",
    label: "Đơn vị cập nhật",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
  },
  {
    key: "NoiDungCapNhat",
    label: "Nội dung cập nhật",
  },
  {
    key: "VanBanLienQuan",
    label: "Văn bản",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
  },
];

export const DANH_SACH_THEO_DOI_TINH_HINH_NHIEM_VU = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "SoKyHieu",
    label: "Số/Ký hiệu",
  },
  {
    key: "NguoiCapNhat",
    label: "Người cập nhật",
  },
  {
    key: "DonViCapNhat",
    label: "Đơn vị cập nhật",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
  },
  {
    key: "NoiDungCapNhat",
    label: "Nội dung cập nhật",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
  },
];

export const DANH_SACH_LICH_SU_TRA_LAI = [
  {
    key: "NguoiXuLy",
    label: "Người trả lại",
    thClass: "w-15",
  },
  {
    key: "DonViXuLy",
    label: "Đơn vị trả lại",
    thClass: "w-15",
  },
  {
    key: "ThoiGianTao",
    label: "Thời gian",
    thClass: "w-15",
  },
  {
    key: "NoiDung",
    label: "Nội dung trả lại",
    thClass: "w-15",
  },
  {
    key: "NguoiTaoXuLy",
    label: "Người bị trả lại",
    thClass: "w-15",
  },
  {
    key: "DonViTaoXuLy",
    label: "Đơn vị bị trả lại",
    thClass: "w-15",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
    thClass: "w-10",
  },
];

export const DANH_SACH_LICH_SU_THU_HOI = [
  {
    key: "NguoiTaoXuLy",
    label: "Người thu hồi",
    thClass: "w-10",
  },
  {
    key: "DonViTaoXuLy",
    label: "Đơn vị thu hồi",
    thClass: "w-20",
  },
  {
    key: "ThoiGianTao",
    label: "Thời gian",
    thClass: "w-10",
  },
  {
    key: "NoiDung",
    label: "Nội dung thu hồi",
    thClass: "w-30",
  },
  {
    key: "NguoiXuLy",
    label: "Người bị thu hồi",
    thClass: "w-15",
  },
  {
    key: "DonViXuLy",
    label: "Đơn vị bị thu hồi",
    thClass: "w-15",
  },
];
export const DANH_SACH_LICH_SU_DON_DOC = [
  {
    key: "NguoiTaoXuLy",
    label: "Người đôn đốc",
    thClass: "w-15",
  },
  {
    key: "DonViTaoXuLy",
    label: "Đơn vị đôn đốc",
    thClass: "w-15",
  },
  {
    key: "ThoiGianTao",
    label: "Thời gian",
    thClass: "w-10",
  },
  {
    key: "NoiDung",
    label: "Nội dung đôn đốc",
    thClass: "w-30",
  },
  {
    key: "NguoiXuLy",
    label: "Người bị đôn đốc",
    thClass: "w-15",
  },
  {
    key: "DonViXuLy",
    label: "Đơn vị bị đôn đốc",
    thClass: "w-15",
  },
];

export const DANH_SACH_VPCP_DON_DOC = [
  {
    key: "NguoiDonDoc",
    label: "Người đôn đốc",
    thClass: "w-20",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
    thClass: "w-15",
  },
  {
    key: "NoiDung",
    label: "Nội dung",
    thClass: "w-40",
  },
  {
    key: "HinhThuc",
    label: "Hình thức",
    thClass: "w-10",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
    thClass: "w-15",
  },
];

export const DANH_SACH_VPCP_TIEN_DO_XU_LY = [
  {
    key: "NguoiCapNhat",
    label: "Người cập nhật",
    thClass: "w-20",
  },
  {
    key: "NgayCapNhat",
    label: "Ngày cập nhật",
    thClass: "w-15",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
    thClass: "w-10",
  },
  {
    key: "NoiDung",
    label: "Nội dung",
    thClass: "w-40",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
    thClass: "w-15",
  },
];

export const DANH_SACH_VPCP_GUI_DIEU_CHINH = [
  {
    key: "NguoiDieuChinhThoiHan",
    label: "Người điều chỉnh",
    thClass: "w-15",
  },
  {
    key: "TenDonViDuocGiao",
    label: "Tên đơn vị được giao",
    thClass: "w-10",
  },
  {
    key: "VanBanDieuChinhThoiHan",
    label: "Văn bản điều chỉnh thời hạn",
    thClass: "w-10",
  },
  {
    key: "NgayThucHienDieuChinhThoiHan",
    label: "Ngày thực hiện",
    thClass: "w-10",
  },
  {
    key: "HanCu",
    label: "Hạn cũ",
    thClass: "w-10",
  },
  {
    key: "HanMoi",
    label: "Hạn mới",
    thClass: "w-10",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
    thClass: "w-10",
  },
  {
    key: "LyDo",
    label: "Lý do từ chối",
    thClass: "w-10",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
    thClass: "w-15",
  },
];

export const DANH_SACH_GUI_TRA_VPCP = [
  {
    key: "NguoiGui",
    label: "Người gửi",
    thClass: "w-15",
  },
  {
    key: "NgayGui",
    label: "Ngày gửi",
    thClass: "w-15",
  },
  {
    key: "NoiDung",
    label: "Nội dung",
    thClass: "w-35",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
    thClass: "w-15",
  },
  {
    key: "TenDonViDuocGiao",
    label: "Tên đơn vị được giao",
    thClass: "w-20",
  },
];
export const DANH_SACH_FILE_DINH_KEM = [
  {
    key: "STT",
    label: "STT",
  },
  {
    key: "Ten",
    label: "Tên file",
  },
  {
    key: "LoaiFileDinhKem",
    label: "Loại tệp đính kèm",
  },
  {
    key: "KySo",
    label: "Ký số",
  },
  {
    key: "HoatDong",
    label: "Hoạt động",
  },
];

export const GIA_TRI_TRANG_THAI_XU_LY = {
  TAT_CA: null,
  DA_HOAN_THANH: 0,
  DEN_HAN: 1,
  QUA_HAN: 2,
  TRONG_HAN: 3,
  KHONG_CO_HAN: 4,
  TRA_LAI: 6,
};

export const GIA_TRI_TRANG_THAI_NHIEM_VU = {
  CHO_PHAN_XU_LY: "CHO_PHAN_XU_LY",
  CHUA_THUC_HIEN: "CHUA_THUC_HIEN",
  KHONG_CO_HAN: 4,
  DA_HOAN_THANH: "DA_HOAN_THANH",
  DA_TRA_LAI_VPCP: "TRA_LAI_VPCP",
  DA_TRA_LAI: "TRA_LAI",
  THU_HOI: "THU_HOI",
  DANG_THUC_HIEN: "DANG_THUC_HIEN",
  HUY: "HUY",
};

export const MANG_TRANG_THAI_XU_LY_CONG_VIEC = [
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.TAT_CA,
    text: "Tất cả",
    color: "#495057",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.DA_HOAN_THANH,
    text: "Công việc đã hoàn thành",
    color: "#495057",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.DEN_HAN,
    text: "Công việc đến hạn",
    color: "#f59a23",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.QUA_HAN,
    text: "Công việc quá hạn",
    color: "#d9001b",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.TRONG_HAN,
    text: "Công việc trong hạn",
    color: "#495057",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.TRA_LAI,
    text: "Trả lại",
    color: "#333333",
  },
];

export const MANG_TRANG_THAI_XU_LY = [
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.TAT_CA,
    text: "Tất cả",
    color: "#495057",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.DA_HOAN_THANH,
    text: "Nhiệm vụ đã hoàn thành",
    color: "#495057",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.DEN_HAN,
    text: "Nhiệm vụ đến hạn",
    color: "#f59a23",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.QUA_HAN,
    text: "Nhiệm vụ quá hạn",
    color: "#d9001b",
  },
  {
    value: GIA_TRI_TRANG_THAI_XU_LY.TRONG_HAN,
    text: "Nhiệm vụ trong hạn",
    color: "#495057",
  },
  // {
  //   value: GIA_TRI_TRANG_THAI_XU_LY.TRA_LAI,
  //   text: "Trả lại CP/VPCP",
  //   color: "#495057",
  // },
];
export const DANH_SACH_CONG_VIEC = [
  {
    key: "CheckBox",
    label: "",
  },
  {
    key: "Status",
    label: "",
  },
  {
    key: "NoiDungCongViec",
    label: "Nội dung công việc",
  },
  {
    key: "HanXuLy",
    label: "Hạn xử lý",
  },
  {
    key: "NguoiGiaoViec",
    label: "Người giao việc",
  },
  {
    key: "DoiTuongThucHien",
    label: "Đơn vị/ Cá nhân thực hiện",
  },
  {
    key: "TrangThai",
    label: "Trạng thái",
  },
  {
    key: "MaNhiemVu",
    label: "Mã nhiệm vụ",
  },
  {
    key: "HoatDong",
    label: "",
  },
];
export const DANH_SACH_DON_VI_TRONG_HE_THONG = [
  {
    key: "stt",
    label: "STT",
  },
  {
    key: "TenDonVi",
    label: "Tên đơn vị nhận",
  },
  {
    key: "DienTu",
    label: "Điện tử",
  },
  {
    key: "Giay",
    label: "Giấy",
  },
  {
    key: "DienTuVaGiay",
    label: "Điện tử và giấy",
  },
];
export const DANH_SACH_BAO_CAO_TONG_HOP_THUC_HIEN = [
  {
    dataIndex: "TongSoNhiemVu",
    title: "Tổng số nhiệm vụ được giao",
    key: "TongSoNhiemVu",
  },
  {
    dataIndex: "NhiemVuKhongMat",
    titlel: "Nhiệm vụ giao tại văn bản không mật",
    key: "NhiemVuKhongMat",
  },
  {
    dataIndex: "NhiemVuMat",
    title: "Nhiệm vụ giao tại văn bản mật",
    key: "NhiemVuMat",
  },
  {
    dataIndex: "NhiemVuHoanThanh",
    title: "Số nhiệm vụ hoàn thành",
    key: "NhiemVuHoanThanh",
  },
  {
    dataIndex: "NhiemVuChuaHoanThanh",
    title: "Số nhiệm vụ chưa hoàn thành",
    key: "NhiemVuChuaHoanThanh",
  },
];
export const DANH_SACH_DON_VI_NGOAI_HE_THONG = [
  {
    key: "stt",
    label: "STT",
  },
  {
    key: "Name",
    label: "Tên đơn vị nhận",
  },
  {
    key: "TrangThai",
    label: "Tình trạng liên thông",
  },
  {
    key: "DienTu",
    label: "Điện tử",
  },
  {
    key: "Giay",
    label: "Giấy",
  },
  {
    key: "DienTuVaGiay",
    label: "Điện tử và giấy",
  },
];

export const DANH_SACH_LICH_SU_KY = [
  {
    key: "stt",
    label: "STT",
    tdClass: "text-center",
  },
  {
    key: "DonViGui",
    label: "Đơn vị gửi",
    tdClass: "text-left",
  },
  {
    key: "NoiDungCapNhat",
    label: "Nội dung ký duyệt",
    tdClass: "text-left",
  },
  {
    key: "DonViNhan",
    label: "Đơn vị nhận",
    tdClass: "text-left",
  },
  {
    key: "NguoiGui",
    label: "Người gửi",
    tdClass: "text-left",
  },
  {
    key: "NguoiNhan",
    label: "Người nhận",
    tdClass: "text-left",
  },
  {
    key: "ThoiGian",
    label: "Thời gian",
    tdClass: "text-center",
  },
  {
    key: "Action",
    label: "Trạng thái",
    tdClass: "text-center",
  },
  {
    key: "Files",
    label: "File đính kèm",
  },
];

export const DANH_SACH_VAN_BAN_TRA_LOI = [
  {
    field: "IsKhongTuDongHoanThanh",
    header: "Được tự động hoàn thành",
    bodyClass: "text-center",
    headerClass: "w-5 bg-color",
  },
  {
    field: "SoDen",
    header: "Số đến",
    headerClass: "w-5 bg-color",
    bodyClass: "text-right",
  },
  {
    field: "SoKyHieu",
    header: "Số/Ký hiệu",
    headerClass: "w-10 bg-color",
    bodyClass: "text-left",
  },
  {
    field: "DonViBanHanh",
    header: "Đơn vị ban hành",
    headerClass: "w-20 bg-color",
    bodyClass: "text-left",
  },
  {
    field: "TrichYeu",
    header: "Trích yếu",
    headerClass: "w-30 bg-color",
    bodyClass: "text-left",
  },
  {
    field: "Files",
    header: "Tệp đính kèm",
    headerClass: "w-25 bg-color",
    bodyClass: "text-left",
  },
  {
    field: "thaoTac",
    header: "Xóa",
    headerClass: "w-5 bg-color",
    bodyClass: "text-center",
  },
];
export const DANH_SACH_DON_VI_CHI_DAO = [
  {
    key: "stt",
    label: "STT",
    width: "60px",
  },
  {
    key: "TenDonVi",
    label: "Tên đơn vị/ cá nhân",
  },
  {
    key: "noiDungChiDao",
    label: "Nội dung chỉ đạo",
  },
  {
    key: "ngayXuLy",
    label: "Ngày xử lý",
    width: "80px",
  },
  {
    key: "thaoTac",
    label: "Xóa",
    width: "60px",
  },
];
export const DANH_SACH_DON_VI_KY_DUYET = [
  {
    key: "stt",
    label: "STT",
  },
  {
    key: "HoTen",
    label: "Họ và tên",
  },
  {
    key: "DonVi",
    label: "Đơn vị",
  },
  {
    key: "vaiTro",
    label: "Vai trò",
  },
  {
    key: "Loai",
    label: "Ban hành",
  },
];
export const DANH_SACH_TAI_LEN = [
  {
    key: "stt",
    label: "STT",
  },
  {
    key: "Ten",
    label: "Tên tệp",
  },
  {
    key: "donViNhan",
    label: "Đơn vị nhận",
  },
  {
    key: "xem",
    label: "Xem",
  },
  {
    key: "sua",
    label: "Sửa",
  },
  {
    key: "kySo",
    label: "Ký số",
  },
  {
    key: "kyDienTu",
    label: "Ký điện tử",
  },
  {
    key: "thaoTac",
    label: "Xóa",
  },
];

export const DANH_SACH_TAI_LEN_CO_QUAN = [
  {
    key: "stt",
    label: "STT",
  },
  {
    key: "Ten",
    label: "Tên tệp",
  },
  {
    key: "donViNhan",
    label: "Đơn vị nhận",
  },
  {
    key: "xem",
    label: "Xem",
  },
  {
    key: "sua",
    label: "Sửa",
  },
  {
    key: "kySo",
    label: "Ký số cơ quan",
  },
  {
    key: "kyDienTu",
    label: "Ký điện tử",
  },
  {
    key: "thaoTac",
    label: "Xóa",
  },
];
export const DANH_SACH_CONG_VIEC_LIEN_QUAN = {
  STT: "STT",
  NGAY_GIAO_VIEC: "Ngày giao việc",
  HAN_XU_LY: "Hạn xử lý",
  NOI_DUNG_CONG_VIEC: "Nội dung công việc",
  TRANG_THAI_XU_LY: "Trạng thái xử lý",
  NGUOI_THUC_HIEN: "Người thực hiện",
  DON_VI_THUC_HIEN: "Đơn vị thực hiện",
};

export const GIA_TRI_DANH_SACH_CAN_BO_LANH_DAO = {
  STT: "STT",
  HO_TEN: "Họ và tên",
};

export const DANH_SACH_CAN_BO_LANH_DAO = [
  { key: "Stt", label: GIA_TRI_DANH_SACH_CAN_BO_LANH_DAO.STT },
  { key: "HoTen", label: GIA_TRI_DANH_SACH_CAN_BO_LANH_DAO.HO_TEN },
  {
    key: "Hoatdong",
    label: "Hoạt động",
  },
];

export const LOAI_DU_LIEU = {
  NHIEM_VU: "NHIEM_VU",
  CONG_VIEC: "CONG_VIEC",
};

export const DANH_SACH_LOAI_CONG_VIEC_CA_NHAN = [
  {
    key: "donVi",
    label: "Đơn vị",
  },
  {
    key: "soNhiemVuQuaHan",
    label: "Số nhiệm vụ quá hạn",
  },
];
export const DONG_Y_BUTTON_LABEL = "Đồng ý";
export const BO_QUA_BUTTON_LABEL = "Bỏ qua";

export const PHAN_HE_THONG_BAO = {
  NHIEM_VU: "NHIEM_VU",
  HO_SO_CONG_VIEC: "HO_SO_CONG_VIEC",
  VAN_BAN_DI: "VAN_BAN_DI",
  VAN_BAN_DEN: "VAN_BAN_DEN",
};

export const PHAN_HE = {
  HO_SO_CONG_VIEC: "HO_SO_CONG_VIEC",
  NHIEM_VU: "NHIEM_VU",
  VAN_BAN_DEN: "VAN_BAN_DEN",
  VAN_BAN_DI: "VAN_BAN_DI",
};

export const CHUC_NANG_THONG_BAO = {
  VAN_BAN_DI: "VAN_BAN_DI",
  VAN_BAN_DEN: "VAN_BAN_DEN",
  SCAN: "SCAN",
};

export const NHIEM_VU_CA_NHAN_TAB_INDEX = {
  NHIEM_VU: 0,
  CONG_VIEC: 1,
};

export const BANG_DANH_SACH_TEMPALTE = {
  Stt: "STT",
  Ten: "Tên",
  NoiDung: "Nội dung",
  ThaoTac: "Thao tác",
};

export const BANG_DANH_SACH_MAU_DU_THAO = {
  Stt: "STT",
  Ten: "Tên mẫu",
  NoiDung: "Trạng thái",
  MoTa: "Mô tả",
  ThaoTac: "Thao tác",
};

export const LOAI_HANH_DONG_TEMPLATE = {
  THEM_MOI: 1,
  SUA: 2,
  XOA: 3,
  XEM: 4,
  DONG: 5,
  SAO_CHEP: 6,
};

export const GIA_TRI_DANH_SACH_COT_NHIEM_VU = [
  "NgayVanBan",
  "SoKyHieuVanBan",
  "TrichYeuVanBan",
  "NoiDungTheoDoi",
  "TinhHinhThucHienNoiBo",
  "ChuTri",
  "PhoiHop",
  "HanXuLy",
  "NoiDungDonDoc",
  "ChuyenVienTheoDoi",
  "HanXuLyVPCP",
];

export const GIA_TRI_DANH_SACH_COT_DANH_MUC = [
  "TenDanhMucHoSo",
  "TenChucVu",
  "TenNguoiTao",
  "CanCu",
  "SoHoSoCoThoiHan",
  "SoHoSoVinhVien",
  "TenTrangThai",
];

export const DANH_SACH_COT_NHIEM_VU_BAN_DAU = [
  { text: "Ngày văn bản", value: "NgayVanBan" },
  { text: "Số/Ký hiệu văn bản", value: "SoKyHieuVanBan" },
  { text: "Trích yếu văn bản", value: "TrichYeuVanBan" },
  { text: "Nội dung theo dõi", value: "NoiDungTheoDoi" },
  { text: "Tình hình thực hiện", value: "TinhHinhThucHienNoiBo" },
  { text: "Hạn xử lý", value: "HanXuLy" },
  { text: "Nội dung đôn đốc", value: "NoiDungDonDoc" },
  { text: "Chuyên viên theo dõi", value: "ChuyenVienTheoDoi" },
  { text: "Hạn xử lý VPCP", value: "HanXuLyVPCP" },
  { text: "Chủ trì", value: "ChuTri" },
  { text: "Phối hợp", value: "PhoiHop" },
  { text: "Tình hình thực hiện phân xử lý", value: "TinhHinhPhanXuLy" },
  { text: "Số nhiệm vụ", value: "SoNhiemVu" },
  { text: "Loại nhiệm vụ", value: "LoaiNhiemVu" },
  { text: "Công việc con", value: "CongViecCon" },
  { text: "Trạng thái xử lý", value: "TrangThaiHanXuLy" },
  { text: "Trạng thái", value: "TrangThai" },
  { text: "Ngày tạo nhiệm vụ", value: "NgayTaoNhiemVu" },
  { text: "ĐV theo dõi", value: "DonViTheoDoi" },
  //{ text: "Diễn giải trạng thái", value: "DienGiaiTrangThai" },
  { text: "Ngày hoàn thành", value: "NgayHoanThanh" },
  { text: "Tên Đơn vị/ Cá nhân bị đôn đốc", value: "TenDonViCaNhanBiDonDoc" },
  //{ text: "Người giao việc", value: "NguoiGiaoViec" },
  //{ text: "Nội dung ý kiến", value: "NoiDungYKien" },
  { text: "Tên Đơn vị/ Cá nhân trả lại", value: "TenDonViCaNhanTraLai" },
  { text: "Nội dung trả lại", value: "NoiDungTraLai" },
  { text: "Tên Đơn vị/ Cá nhân bị thu hồi", value: "TenDonViCaNhanThuHoi" },
  { text: "Nội dung thu hồi", value: "NoiDungThuHoi" },
  //{ text: "Đã gửi VPCP", value: "DaGuiVPCP" },
];

export const DANH_SACH_COT_VAN_BAN_DEN_BAN_DAU = [
  { text: "Ngày đến", value: "NgayDen" },
  { text: "Nơi gửi", value: "NoiGui" },
  { text: "Số/Ký hiệu", value: "SoKyHieu" },
  { text: "Ngày ban hành", value: "NgayBanHanh" },
  { text: "Trích yếu", value: "TrichYeu" },
  { text: "Số đến", value: "SoDen" },
  { text: "Chủ trì", value: "ChuTri" },
  { text: "Phối hợp", value: "PhoiHop" },
  { text: "Chỉ đạo", value: "LanhDaoChiDao" },
  { text: "Trạng thái xử lý", value: "TrangThaiXuLy" },
  { text: "Có ký số", value: "HasKySo" },
  { text: "Loại đến", value: "LoaiDen" },
  { text: "Độ khẩn", value: "DoKhan" },
  { text: "Sổ văn bản", value: "SoVanBan" },
  { text: "Loại văn bản", value: "LoaiVanBan" },
  { text: "Tên đơn vị/cá nhân bị thu hồi", value: "TenDonViCaNhanThuHoi" },
  { text: "Nội dung thu hồi", value: "NoiDungThuHoi" },
  { text: "Tên đơn vị/cá nhân trả lại", value: "TenDonViCaNhanTraLai" },
  { text: "Nội dung trả lại", value: "NoiDungTraLai" },
  { text: "Ngày hoàn thành xử lý", value: "NgayHoanThanh" },
  { text: "Ngày hạn xử lý", value: "HanXuLy" },
  { text: "Hạn xử lý", value: "NgayHanXuLy" },
  { text: "Người ký", value: "NguoiKy" },
  { text: "Số bản", value: "SoBan" },
  { text: "Số trang", value: "SoTrang" },
  { text: "Ngày nhận bản giấy", value: "NgayNhanBanGiay" },
  { text: "Là văn bản Bộ giao", value: "NguonDen" },
];

export const DANH_SACH_COT_VAN_BAN_DEN_Y_KIEN_BAN_DAU = [
  { text: "Ngày đến", value: "NgayDen" },
  { text: "Ngày ban hành", value: "NgayBanHanh" },
  { text: "Số/Ký hiệu", value: "SoKyHieu" },
  { text: "Trạng thái xử lý", value: "TrangThaiXuLy" },
  { text: "Trạng thái", value: "MaTrangThai" },
  { text: "Trích yếu", value: "TrichYeu" },
  { text: "Có ký số", value: "KySo" },
  { text: "Nơi gửi", value: "NoiGui" },
  { text: "Loại đến", value: "LoaiDen" },
  { text: "Cá nhân được xin ý kiến", value: "CaNhanDuocXinYKien" },
  { text: "Chỉ đạo", value: "LanhDaoChiDao" },
  { text: "Sổ văn bản", value: "SoVanBan" },
  { text: "Số đến", value: "SoDen" },
  { text: "Loại văn bản", value: "LoaiVanBan" },
  { text: "Tên đơn vị/cá nhân bị thu hồi", value: "TenDonViCaNhanThuHoi" },
  { text: "Nội dung thu hồi", value: "NoiDungThuHoi" },
  { text: "Tên đơn vị/cá nhân trả lại", value: "TenDonViCaNhanTraLai" },
  { text: "Nội dung trả lại", value: "NoiDungTraLai" },
  { text: "Ngày hoàn thành xử lý", value: "NgayHoanThanh" },
  { text: "Ngày hạn xử lý", value: "HanXuLy" },
  { text: "Hạn xử lý", value: "NgayHanXuLy" },
  { text: "Người ký", value: "NguoiKy" },
  { text: "Độ khẩn", value: "DoKhan" },
  { text: "Số bản", value: "SoBan" },
  { text: "Số trang", value: "SoTrang" },
  { text: "Ngày nhận bản giấy", value: "NgayNhanBanGiay" },
];

export const GIA_TRI_DANH_SACH_COT_VAN_BAN_DEN = [
  "NgayDen",
  "NoiGui",
  "SoKyHieu",
  "NgayBanHanh",
  "TrichYeu",
  "SoDen",
  "ChuTri",
  "PhoiHop",
  "NguonDen"
];

export const GIA_TRI_DANH_SACH_COT_CONG_VIEC = [
  "MaNhiemVu",
  "NoiDungCongViec",
  "HanXuLy",
  "NgayHanXuLy",
  "NguoiGiaoViec",
  "DoiTuongThucHien",
  "TrangThaiHanXuLy",
  "TrangThai",
  "NguoiKy",
  "DoKhan",
  "SoBan",
  "SoTrang",
  "NgayNhanBanGiay",
];

export const DANH_SACH_COT_CONG_VIEC_BAN_DAU = [
  { text: "Mã nhiệm vụ", value: "MaNhiemVu" },
  { text: "Nội dung theo dõi", value: "NoiDungCongViec" },
  { text: "Hạn xử lý", value: "HanXuLy" },
  { text: "Người giao việc", value: "NguoiGiaoViec" },
  { text: "Đối tượng thực hiện", value: "DoiTuongThucHien" },
  { text: "Trạng thái xử lý", value: "TrangThaiHanXuLy" },
  { text: "Trạng thái", value: "TrangThai" },
  { text: "Tên nhiệm vụ", value: "TenNhiemVu" },
  { text: "Đơn vị giao việc", value: "DonViGiaoViec" },
  { text: "Mức độ công việc", value: "MucDoCongViec" },
  { text: "Công việc liên quan", value: "CongViecLienQuan" },
];
export const DANH_SACH_COT_DANH_MUC = [
  { text: "Tiêu đề", value: "TenDanhMucHoSo" },
  { text: "Chức vụ", value: "TenChucVu" },
  { text: "Người tạo", value: "TenNguoiTao" },
  { text: "Căn cứ", value: "CanCu" },
  { text: "Hồ sơ có thời hạn", value: "SoHoSoCoThoiHan" },
  { text: "Hồ sơ vĩnh viễn", value: "SoHoSoVinhVien" },
  { text: "Trạng thái", value: "TenTrangThai" },
];

export const MA_TRANG_THAI_CONG_VIEC_NHIEM_VU = {
  CHUA_THUC_HIEN: "CHUA_THUC_HIEN",
  DANG_THUC_HIEN: "DANG_THUC_HIEN",
  DA_HOAN_THANH: "DA_HOAN_THANH",
  CHO_PHAN_XU_LY: "CHO_PHAN_XU_LY",
  HUY: "HUY",
};

export const MA_MUC_DO_CONG_VIEC = {
  THUONG: "THUONG",
  GAP: "GAP",
};

export const MANG_TRANG_THAI_GUI_VPCP = [
  { value: null, text: "Tất cả" },
  { value: true, text: "Đã gửi" },
  { value: false, text: "Chưa gửi" },
];

export const KEY_CODE = {
  DAU_CONG: 107,
  DAU_BANG: 187,
  DAU_BANG_FIREFOX: 61,
  S: 83,
  C: 67,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  ENTER: 13,
};

// văn bản đến

export const GIA_TRI_HAN_XU_LY_VAN_BAN_DEN = {
  TAT_CA: 0,
  QUA_HAN_XU_LY: 1,
  HAN_XU_LY_CON_KHONG_QUA_HAI_NGAY: 2,
  HAN_XU_LY_CON_NHIEU_HON_HAI_NGAY: 3,
  DA_XU_LY: 5,
  KHONG_PHAI_XU_LY: 6,
};

export const MANG_HAN_XU_LY_VAN_BAN_DEN = [
  {
    value: GIA_TRI_HAN_XU_LY_VAN_BAN_DEN.TAT_CA,
    text: "Tất cả",
  },
  {
    value: GIA_TRI_HAN_XU_LY_VAN_BAN_DEN.QUA_HAN_XU_LY,
    text: "Quá hạn",
  },
  {
    value: GIA_TRI_HAN_XU_LY_VAN_BAN_DEN.HAN_XU_LY_CON_KHONG_QUA_HAI_NGAY,
    text: "Đến hạn",
  },
  {
    value: GIA_TRI_HAN_XU_LY_VAN_BAN_DEN.HAN_XU_LY_CON_NHIEU_HON_HAI_NGAY,
    text: "Trong hạn",
  },
  {
    value: GIA_TRI_HAN_XU_LY_VAN_BAN_DEN.DA_XU_LY,
    text: "Đã xử lý",
  },
];

export const PHUONG_THUC_NHAN_VAN_BAN = {
  TAT_CA: null,
  BAN_GIAY: "BAN_GIAY",
  DIEN_TU: "DIEN_TU",
  BAN_GIAY_VA_DIEN_TU: "BAN_GIAY_VA_DIEN_TU",
};

export const MANG_GIA_TRI_LOAI_DEN = [
  {
    value: PHUONG_THUC_NHAN_VAN_BAN.TAT_CA,
    text: "Tất cả",
  },
  {
    value: PHUONG_THUC_NHAN_VAN_BAN.BAN_GIAY,
    text: "Bản giấy",
  },
  {
    value: PHUONG_THUC_NHAN_VAN_BAN.DIEN_TU,
    text: "Điện tử",
  },
  {
    value: PHUONG_THUC_NHAN_VAN_BAN.BAN_GIAY_VA_DIEN_TU,
    text: "Bản giấy và Điện tử",
  },
];

export const DANH_SACH_LICH_SU_CAP_NHAT_TINH_HINH_VAN_BAN = [
  {
    key: "NguoiTaoXuLy",
    label: "Người cập nhật",
  },
  {
    key: "DonViTaoXuLy",
    label: "Đơn vị cập nhật",
  },
  {
    key: "ThoiGianTao",
    label: "Thời gian",
  },
  {
    key: "NoiDung",
    label: "Nội dung",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
  },
];

export const DANH_SACH_LICH_SU_XIN_Y_KIEN = [
  {
    key: "NguoiTaoXuLy",
    label: "Người xin ý kiến",
  },
  {
    key: "NguoiXuLy",
    label: "Người được xin ý kiến",
  },
  {
    key: "NoiDungXinYKien",
    label: "Nội dung xin ý kiến",
  },
  {
    key: "ThoiGianTao",
    label: "Thời gian",
  },
  {
    key: "LstFileDinhKemXinYKien",
    label: "File đính kèm",
  },
  {
    key: "hoatDong",
    label: "Thao tác",
  },
];

export const DANH_SACH_LICH_SU_TRA_LAI_VAN_BAN = [
  {
    key: "NguoiXuLy",
    label: "Người trả lại",
  },
  {
    key: "DonViXuLy",
    label: "Đơn vị trả lại",
  },
  {
    key: "ThoiGianTao",
    label: "Thời gian",
  },
  {
    key: "NoiDung",
    label: "Nội dung trả lại",
  },
  {
    key: "NguoiTaoXuLy",
    label: "Người bị trả lại",
  },
  {
    key: "DonViTaoXuLy",
    label: "Đơn vị bị trả lại",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
  },
];

export const DANH_SACH_LICH_SU_THU_HOI_VAN_BAN = [
  {
    key: "NguoiXuLy",
    label: "Người bị thu hồi",
  },
  {
    key: "DonViXuLy",
    label: "Đơn vị bị thu hồi",
  },
  {
    key: "DonViTaoXuLy",
    label: "Đơn vị thu hồi",
  },
  {
    key: "ThoiGianTao",
    label: "Thời gian",
  },
  {
    key: "NguoiTaoXuLy",
    label: "Người thu hồi",
  },
  {
    key: "NoiDung",
    label: "Nội dung thu hồi",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
  },
];

export const DANH_SACH_VAN_BAN_LIEN_THONG = [
  {
    key: "NguoiTaoXuLy",
    label: "Người tạo xử lý",
  },
  {
    key: "DonViTaoXuLy",
    label: "Đơn vị tạo xử lý",
  },

  {
    key: "ThoiGianTao",
    label: "Thời gian tạo xử lý",
  },
  {
    key: "ThoiGianTao",
    label: "Thời gian",
  },
  {
    key: "NoiDung",
    label: "Nội dung xử lý",
  },
  {
    key: "NguoiXuLy",
    label: "Người xử lý",
  },
  {
    key: "DonViXuLy",
    label: "Đơn vị xử lý",
  },
  {
    key: "HoatDong",
    label: "Hoạt động",
  },
  {
    key: "FileDinhKems",
    label: "File đính kèm",
  },
];

export const DANH_SACH_BAO_CAO_IN_SO = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "SoKyHieu",
    label: "Số/ Ký hiệu văn bản",
  },
  {
    key: "NgayThangVanBan",
    label: "Ngày tháng văn bản",
  },
  {
    key: "TrichYeu",
    label: "Tên loại và trích yếu nội dung văn bản",
  },
  {
    key: "NguoiKy",
    label: "Người ký",
  },
  {
    key: "NoiNhan",
    label: "Nơi nhận văn bản",
    tdClass: "text-left",
  },
  {
    key: "DonViSoanThaoBanLuu",
    label: "Đơn vị, người nhận bản lưu",
  },
  {
    key: "SoLuongBan",
    label: "Số lượng bản",
  },
  {
    key: "NgayChuyen",
    label: "Ngày chuyển",
  },
  {
    key: "KyNhan",
    label: "Ký nhận",
  },
  {
    key: "GhiChu",
    label: "Ghi chú",
  },
];

export const DANH_SACH_BAO_CAO_SO_LUONG = [
  {
    key: "Stt",
    label: "STT",
    thClass: "border-top-none",
    thStyle: "border-top: none !important; padding: 0 !important",
  },
  {
    key: "TenDonVi",
    label: "Đơn vị nhận",
    thStyle: "border-top: none !important; padding: 0 !important",
  },
  {
    key: "SoLuongVanBanDienTu",
    label: "Điện tử",
  },
  {
    key: "SoLuongVanBanGiay",
    label: "Bản giấy",
  },
  {
    key: "SoLuongVanBanDienTuVaGiay",
    label: "Điện tử và giấy",
  },
];

export const DANH_SACH_BAO_CAO_CHI_TIET_VAN_BAN_DI = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "SoKyHieu",
    label: "Số/Ký hiệu",
  },
  {
    key: "TrichYeu",
    label: "Trích yếu	",
  },
  {
    key: "DonViSoanThao",
    label: "Đơn vị soạn thảo	",
  },
  {
    key: "NgayBanHanh",
    label: "Ngày phát hành	",
  },
  {
    key: "NoiNhan",
    label: "Nơi nhận",
    tdClass: "text-left",
  },
];

export const DANH_SACH_BAO_CAO_MOI_TONG_HOP = [
  {
    key: "TongSo",
    label: "Tổng số",
  },
  {
    key: "SoKyHieu",
    label: "Số/Ký hiệu",
  },
  {
    key: "TrichYeu",
    label: "Trích yếu	",
  },
  {
    key: "HoanThanh_DungHan",
    label: "Đơn vị soạn thảo	",
  },
  {
    key: "HoanThanh_QuaHan",
    label: "Ngày phát hành	",
  },
  {
    key: "ChuaHoanThanh_TrongHan",
    label: "Nơi nhận",
  },
  {
    key: "ChuaHoanThanh_QuaHan",
    label: "Nơi nhận",
  },
];

export const DANH_SACH_BAO_CAO_MOI_CHI_TIET = [
  {
    key: "STT",
    label: "Tổng số",
  },
  {
    key: "VanBanGiaoNhiemVu",
    label: "Số/Ký hiệu",
    bodyClass: "text-left",
  },
  {
    key: "TrichYeu",
    label: "Trích yếu",
    bodyClass: "text-left",
  },
  {
    key: "HanXuLy",
    label: "Đơn vị soạn thảo",
    bodyClass: "text-center",
    tdClass: "text-center",
  },
  {
    key: "HoanThanh_QuaHan",
    label: "Ngày phát hành	",
  },
];

export const DANH_SACH_BAO_CAO_THONG_KE = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "NgayThangVanBan",
    label: "Ngày văn bản",
  },
  {
    key: "SoDi",
    label: "Số đi",
  },
  {
    key: "SoKyHieu",
    label: "Số/Ký hiệu",
  },
  {
    key: "TrichYeu",
    label: "Trích yếu",
  },
  {
    key: "LoaiVanBan",
    label: "Loại văn bản",
  },
  {
    key: "NoiNhan",
    label: "Nơi nhận",
    tdClass: "text-left",
  },
];

export const DANH_SACH_SO_LUONG_VB_DI = [
  {
    key: "Stt",
    label: "STT",
  },
  {
    key: "TenDonVi",
    label: "Đơn vị",
  },
  {
    key: "TongSoVanBanDaBanHanh",
    label: "Tổng số văn bản đã ban hành",
  },
  {
    key: "TongSoVanBanCoLuong",
    label: "Tổng số văn bản có luồng",
  },
  {
    key: "TongSoVanBanCoKySoVanBan",
    label: "Tổng số văn bản có ký số",
  },
  {
    key: "TongSoGuiDonViNoiBo",
    label: "Tổng số văn bản gửi nội bộ",
  },
  {
    key: "TongSoGuiDonViNgoai",
    label: "Tổng số văn bản gửi liên thông",
  },
];

export const DANH_SACH_SO_LUONG_CAP_SO = [
  {
    key: "Stt",
    label: "STT",
    thClass: "border-top-none",
    thStyle: "border-top: none !important; padding: 0 !important",
  },
  {
    key: "TenDonVi",
    label: "Tên đơn vị",
    thStyle: "border-top: none !important; padding: 0 !important",
  },
  {
    key: "TongSoLuongDaBanHanh",
    label: "Tổng số đã ban hành",
  },
  {
    key: "SoLuongCapSoGiay",
    label: "Văn bản cấp số giấy",
  },
  {
    key: "SoLuongCapSoDienTu",
    label: "Văn bản cấp số điện tử",
  },
];
export const ACTION_TYPE = {
  LIEN_THONG: "LIEN_THONG",
  VAO_SO: "VAO_SO",
  TAO_MOI: "TAO_MOI",
  PHAN_XU_LY: "PHAN_XU_LY",
  THU_HOI: "THU_HOI",
  THONG_BAO: "THONG_BAO",
  TRA_LAI: "TRA_LAI",
  TRA_LAI_VPCP: "TRA_LAI_VPCP",
  CAP_NHAT_TINH_HINH_THUC_HIEN: "CAP_NHAT_TINH_HINH_THUC_HIEN",
};

export const ACTION_LUONG_XU_LY = [
  {
    name: "Trình ký",
    id: 0,
  },
  {
    name: "Duyệt",
    id: 1,
  },
  {
    name: "Hủy duyệt",
    id: 2,
  },
  {
    name: "Thu hồi",
    id: 3,
  },
  {
    name: "Trả lại",
    id: 4,
  },
  {
    name: "Cấp số",
    id: 5,
  },
  {
    name: "Ban hành",
    id: 6,
  },
  {
    name: "Thu hồi văn bản đi đã ban hành",
    id: 7,
  },
  {
    name: "Hủy trình ký",
    id: 8,
  },
  {
    name: "Trình ký tiếp theo",
    id: 9,
  },
  {
    name: "Khởi tạo văn bản",
    id: 10,
  },
  {
    name: "Cập nhật văn bản",
    id: 11,
  },
];

export const LOAI_NHOM_CONG_VIEC = {
  TAT_CA: null,
  TRONG: 1,
  NGOAI: 2,
  CA_NHAN: 3,
};

export const LOAI_NHOM_TRONG_HE_THONG = {
  DonVi: 1,
  DonViCaNhan: 2,
};

export const MANG_NHOM_CONG_VIEC = [
  {
    value: LOAI_NHOM_CONG_VIEC.TAT_CA,
    text: "Tất cả",
  },
  {
    value: LOAI_NHOM_CONG_VIEC.TRONG,
    text: "Trong hệ thống",
  },
  {
    value: LOAI_NHOM_CONG_VIEC.NGOAI,
    text: "Ngoài hệ thống",
  },
  {
    value: LOAI_NHOM_CONG_VIEC.CA_NHAN,
    text: "Cá nhân",
  },
];

export const MANG_FILE_FIELDS = [
  {
    field: "Stt",
    header: "STT",
    bodyClass: "text-center",
    headerClass: "w-5",
  },
  {
    field: "Ten",
    header: "Tên file",
    bodyClass: "text-left",
    headerClass: "w-100",
  },
  {
    field: "KySo",
    header: "Ký số",
    headerClass: "w-5",
    bodyClass: "text-center",
  },
  {
    field: "Xoa",
    header: "Xóa",
    headerClass: "w-5",
    bodyClass: "text-center",
  },
];

export const MANG_FILE_MODAL_FIELDS = [
  {
    field: "Stt",
    header: "STT",
    bodyClass: "text-center",
    headerClass: "w-5",
  },
  {
    field: "Ten",
    header: "Tên file",
    bodyClass: "text-left",
    headerClass: "w-80",
  },
  {
    field: "KySo",
    header: "Ký số",
    bodyClass: "text-center",
    headerClass: "w-10",
  },
  {
    field: "Xoa",
    header: "Xóa",
    headerClass: "w-5",
    bodyClass: "text-center",
  },
];

export const FIELD_NAME_HOI_BAO_VAN_BAN_DEN = [
  {
    key: "STT",
    label: "STT",
  },
  {
    key: "SoKyHieu",
    label: "Số/ký hiệu",
  },
  {
    key: "SoTTVB",
    label: "Số đi",
  },
  {
    key: "NguoiSoanThao",
    label: "Người soạn thảo",
  },
  {
    key: "TrichYeu",
    label: "Trích yếu",
  },
  {
    key: "Files",
    label: "File đính kèm",
  },
  {
    key: "Xoa",
    label: "Xóa",
  },
];

export const VAN_BAN_DEN_FIELD = {
  NGAY_DEN: "NgayDen",
  NGAY_BAN_HANH: "NgayBanHanh",
  SO_KY_HIEU: "SoKyHieu",
  TRANG_THAI_XU_LY: "TrangThaiXuLy",
  TRANG_THAI: "TrangThai",
  CHU_TRI: "ChuTri",
  PHOI_HOP: "PhoiHop",
  CHI_DAO: "LanhDaoChiDao",
  TRICH_YEU: "TrichYeu",
  NOI_GUI: "NoiGui",
  LOAI_DEN: "LoaiDen",
  DO_KHAN: "DoKhan",
  SO_VAN_BAN: "SoVanBan",
  SO_DEN: "SoDen",
  LOAI_VAN_BAN: "LoaiVanBan",
  NOI_DUNG_THU_HOI: "NoiDungThuHoi",
  TEN_DON_VI_CA_NHAN_THU_HOI: "TenDonViCaNhanThuHoi",
  NOI_DUNG_TRA_LAI: "NoiDungTraLai",
  TEN_DON_VI_CA_NHAN_TRA_LAI: "TenDonViCaNhanTraLai",
  NGAY_HOAN_THANH_XU_LY: "NgayHoanThanh",
  HAN_XU_LY: "NgayHanXuLy",
  NGAY_HAN_XU_LY: "HanXuLy",
  NGUOI_KY: "NguoiKy",
  SO_BAN: "SoBan",
  SO_TRANG: "SoTrang",
  NGAY_NHAN_BAN_GIAY: "NgayNhanBanGiay",
};

export const MANG_VAN_BAN_DEN_FIELDS = [
  {
    field: VAN_BAN_DEN_FIELD.NGAY_DEN,
    header: "Ngày đến",
    bodyClass: "text-left",
    keySearch: "NgayDenFilter",
    width: 15,
  },
  {
    field: VAN_BAN_DEN_FIELD.NGAY_BAN_HANH,
    header: "Ngày ban hành",
    bodyClass: "text-left",
    keySearch: "NgayBanHanhFilter",
    width: 15,
  },
  {
    field: VAN_BAN_DEN_FIELD.SO_KY_HIEU,
    header: "Số/Ký hiệu",
    bodyClass: "text-left",
    keySearch: "SoKyHieuFilter",
    width: 15,
  },
  {
    field: VAN_BAN_DEN_FIELD.TRANG_THAI_XU_LY,
    header: "Trạng thái xử lý",
    bodyClass: "text-left",
    keySearch: "TrangThaiXuLyFilter",
    width: 20,
  },
  {
    field: VAN_BAN_DEN_FIELD.TRANG_THAI,
    header: "Trạng thái",
    bodyClass: "text-left",
    keySearch: "TrangThaiFilter",
    width: 20,
  },
  {
    field: VAN_BAN_DEN_FIELD.TRICH_YEU,
    header: "Trích yếu",
    bodyClass: "text-left",
    keySearch: "TrichYeuFilter",
    width: 35,
  },
  {
    field: VAN_BAN_DEN_FIELD.NOI_GUI,
    header: "Nơi gửi",
    bodyClass: "text-left",
    keySearch: "NoiGuiFilter",
    width: 25,
  },
  {
    field: VAN_BAN_DEN_FIELD.LOAI_DEN,
    header: "Loại đến",
    bodyClass: "text-left",
    keySearch: "LoaiDenFilter",
    width: 20,
  },
  {
    field: VAN_BAN_DEN_FIELD.DO_KHAN,
    header: "Độ khẩn",
    bodyClass: "text-left",
    keySearch: "DoKhanFilter",
    width: 20,
  },
  {
    field: VAN_BAN_DEN_FIELD.SO_VAN_BAN,
    header: "Sổ văn bản",
    bodyClass: "text-left",
    keySearch: "SoVanBanFilter",
    width: 20,
  },
  {
    field: VAN_BAN_DEN_FIELD.SO_DEN,
    header: "Số đến",
    bodyClass: "text-left",
    keySearch: "SoDenFilter",
    width: 20,
  },
  {
    field: VAN_BAN_DEN_FIELD.LOAI_VAN_BAN,
    header: "Loại văn bản",
    bodyClass: "text-left",
    keySearch: "LoaiVanBanFilter",
    width: 20,
  },
  {
    field: VAN_BAN_DEN_FIELD.NOI_DUNG_THU_HOI,
    header: "Nội dung thu hồi",
    bodyClass: "text-left",
    keySearch: "NoiDungThuHoiFilter",
    width: 30,
  },
  {
    field: VAN_BAN_DEN_FIELD.TEN_DON_VI_CA_NHAN_THU_HOI,
    header: "Tên đơn vị cá nhân thu hồi",
    bodyClass: "text-left",
    keySearch: "TenDonViCaNhanThuHoiFilter",
    width: 30,
  },
  {
    field: VAN_BAN_DEN_FIELD.NOI_DUNG_TRA_LAI,
    header: "Nội dung trả lại",
    bodyClass: "text-left",
    keySearch: "NoiDungTraLaiFilter",
    width: 30,
  },
  {
    field: VAN_BAN_DEN_FIELD.TEN_DON_VI_CA_NHAN_TRA_LAI,
    header: "Tên đơn vị cá nhân trả lại",
    bodyClass: "text-left",
    keySearch: "TenDonViCaNhanTraLaiFilter",
    width: 30,
  },
  {
    field: VAN_BAN_DEN_FIELD.NGAY_HOAN_THANH_XU_LY,
    header: "Ngày hoàn thành xử lý",
    bodyClass: "text-left",
    keySearch: "NgayHoanThanhXuLyFilter",
    width: 15,
  },
  {
    field: VAN_BAN_DEN_FIELD.HAN_XU_LY,
    header: "Ngày hạn xử lý",
    bodyClass: "text-left",
    keySearch: "NgayHanXuLyFilter",
    width: 15,
  },
  {
    field: VAN_BAN_DEN_FIELD.NGAY_HAN_XU_LY,
    header: "Hạn xử lý",
    bodyClass: "text-left",
    keySearch: "HanXuLyFilter",
    width: 15,
  },
  {
    field: VAN_BAN_DEN_FIELD.NGUOI_KY,
    header: "Người ký",
    bodyClass: "text-left",
    keySearch: "NguoiKyFilter",
    width: 20,
  },
  {
    field: VAN_BAN_DEN_FIELD.SO_BAN,
    header: "Số bản",
    bodyClass: "text-left",
    keySearch: "SoBanFilter",
    width: 15,
  },
  {
    field: VAN_BAN_DEN_FIELD.SO_TRANG,
    header: "Số trang",
    bodyClass: "text-left",
    keySearch: "SoTrangFilter",
    width: 15,
  },
  {
    field: VAN_BAN_DEN_FIELD.NGAY_NHAN_BAN_GIAY,
    header: "Ngày nhận bản giấy",
    bodyClass: "text-left",
    keySearch: "NgayNhanBanGiayFilter",
    width: 15,
  },
];

export const GIA_TRI_LOAI_TRA_CUU = {
  TAT_CA: "TAT_CA",
  TRA_CUU_THEO_LUONG: "TRA_CUU_THEO_LUONG",
  TRA_CUU_THEO_PHAM_VI: "TRA_CUU_THEO_PHAM_VI",
};

export const MANG_LOAI_TRA_CUU = [
  {
    value: GIA_TRI_LOAI_TRA_CUU.TAT_CA,
    text: "Tất cả",
  },
  {
    value: GIA_TRI_LOAI_TRA_CUU.TRA_CUU_THEO_LUONG,
    text: "Tra cứu theo luồng",
  },
  {
    value: GIA_TRI_LOAI_TRA_CUU.TRA_CUU_THEO_PHAM_VI,
    text: "Tra cứu theo phạm vi",
  },
];

export const LOAI_DU_LIEU_THOI_GIAN = {
  TAT_CA: null,
  TUAN: 1,
  THANG: 2,
  NAM: 3,
};

export const MANG_LOAI_THOI_GIAN = [
  {
    text: "Tất cả",
    value: LOAI_DU_LIEU_THOI_GIAN.TAT_CA,
  },
  {
    text: "Tuần này",
    value: LOAI_DU_LIEU_THOI_GIAN.TUAN,
  },
  {
    text: "Tháng này",
    value: LOAI_DU_LIEU_THOI_GIAN.THANG,
  },
  {
    text: "Năm nay",
    value: LOAI_DU_LIEU_THOI_GIAN.NAM,
  },
];

export const LOAI_DU_LIEU_VAN_BAN_DEN = {
  TAT_CA: null,
  EOFFICE: 1,
  MOI: 2,
  MPI: 3,
};

export const MANG_LOAI_DU_LIEU = [
  {
    text: "Tất cả",
    value: LOAI_DU_LIEU_VAN_BAN_DEN.TAT_CA,
  },
  {
    text: "Dữ liệu mới tạo trên hệ thống",
    value: LOAI_DU_LIEU_VAN_BAN_DEN.MOI,
  },
  {
    text: "Dữ liệu cũ từ EOffice",
    value: LOAI_DU_LIEU_VAN_BAN_DEN.EOFFICE,
  },
  {
    text: "Dữ liệu MPI",
    value: LOAI_DU_LIEU_VAN_BAN_DEN.MPI,
  },
];

export const TRANG_THAI_BAO_CAO_LANH_DAO = [
  {
    text: "Báo cáo mới",
    value: 1,
  },
  {
    text: "Đã bút phê",
    value: 2,
  },
  {
    text: "Đã phân xử lý",
    value: 3,
  },
];

export const OPTIONS_FILE_FILTER = [
  {
    text: "Tất cả",
    value: 0,
  },
  {
    text: "Có tệp",
    value: 1,
  },
  {
    text: "Không có tệp",
    value: 2,
  },
];

export const OPTIONS_KY_SO = [
  {
    text: "Tất cả",
    value: 0,
  },
  {
    text: "Có ký số",
    value: 1,
  },
  {
    text: "Không có ký số",
    value: 2,
  },
];

export const OPTIONS_LIEN_THONG = [
  {
    text: "Tất cả",
    value: null,
  },
  {
    text: "Lỗi liên thông",
    value: 0,
  },
  {
    text: "Liên thông",
    value: 1,
  },
  {
    text: "Nội bộ",
    value: 2,
  },
];

export const OPTIONS_LUONG = [
  {
    text: "Tất cả",
    value: null,
  },
  {
    text: "Có luồng",
    value: true,
  },
  {
    text: "Không có luồng",
    value: false,
  },
];

export const OPTIONS_TRANG_THAI_XIN_SO_BO = [
  {
    text: "Chờ Bộ cấp số",
    value: 1,
  },
  {
    text: "Từ chối",
    value: 2,
  },
];

export const LOCATION_TYPE = {
  PROVINCE: "PROVINCE",
  DISTRICT: "DISTRICT",
  COMMUNES: "COMMUNES",
};

export const ACTION = {
  VAN_BAN_DEN: {
    PHAN_XU_LY: "PHAN_XU_LY",
    SAO_CHEP: "SAO_CHEP",
    TAO_PAKN: "TAO_PAKN",
    TAO_DU_THAO: "TAO_DU_THAO",
    CAP_NHAT_HOAN_THANH: "CAP_NHAT_HOAN_THANH",
    XIN_Y_KIEN: "XIN_Y_KIEN",
    TRA_LAI: "TRA_LAI",
    THU_HOI: "THU_HOI",
    SUA: "SUA",
    XOA: "XOA",
    XEM_LUONG: "XEM_LUONG",
    VAO_SO: "VAO_SO",
    DA_XEM: "DA_XEM",
    TU_CHOI: "TU_CHOI",
    OCR: "OCR",
  },
  NHIEM_VU: {
    TAO_MOI: "TAO_MOI",
    DON_DOC: "DON_DOC",
    TRA_LAI: "TRA_LAI",
    THU_HOI: "THU_HOI",
    CAP_NHAT_THTH: "CAP_NHAT_THTH",
    SUA: "SUA",
    PHAN_XU_LY: "PHAN_XU_LY",
    XEM_LUONG: "XEM_LUONG",
    XOA: "XOA",
  },
  CONG_VIEC: {
    TAO_MOI: "TAO_MOI",
    SUA: "SUA",
    XOA: "XOA",
    CAP_NHAT_THTH: "CAP_NHAT_THTH",
    GAN: "GAN",
    HUY: "HUY",
    LICH_SU: "LICH_SU",
  },
  VAN_BAN_DI: {
    XOA: "XOA",
    SUA: "SUA",
    SAO_CHEP: "SAO_CHEP",
    XEM_LUONG: "XEM_LUONG",
    BAN_HANH: "BAN_HANH",
    TRA_SO: "TRA_SO",
    CAP_SO: "CAP_SO",
    CAP_SO_VA_BAN_HANH: "CAP_SO_VA_BAN_HANH",
    TRINH_KY_TIEP_THEO: "TRINH_KY_TIEP_THEO",
    XIN_Y_KIEN: "XIN_Y_KIEN",
    TRA_LAI: "TRA_LAI",
    TRINH_KY: "TRINH_KY",
    HUY_TRINH_KY: "HUY_TRINH_KY",
    THU_HOI_BAN_HANH: "THU_HOI_BAN_HANH",
    BAN_HANH_BO_SUNG: "BAN_HANH_BO_SUNG",
    DUYET: "DUYET",
    HUY_DUYET: "HUY_DUYET",
    OCR: "OCR",
  },
};

export const DANH_SACH_THAO_TAC_VB_DEN = [
  {
    name: "Xem luồng phân xử lý",
    xemLuong: true,
    icon: "users",
    fontIcon: true,
    value: "xem-luong",
  },
  {
    name: "Sao chép",
    saoChep: true,
    icon: "files",
    value: "sao-chep",
  },
  {
    name: "Phân xử lý",
    phanXuLy: true,
    icon: "share",
    fontIcon: true,
    value: "phan-xu-ly",
  },
  {
    name: "Hoàn thành xử lý",
    hoanThanh: true,
    icon: "edit",
    fontIcon: true,
    value: "hoan-thanh",
  },
  {
    name: "Thu hồi",
    thuHoi: true,
    icon: "undo",
    value: "thu-hoi",
    fontIcon: true,
  },
  {
    name: "Trả lại",
    traLai: true,
    icon: "reply",
    value: "tra-lai",
    fontIcon: true,
  },
  {
    name: "Từ chối",
    tuChoi: true,
    icon: "ban",
    value: "tu-choi",
    fontIcon: true,
  },
  {
    name: "Sửa",
    sua: true,
    icon: "pencil-alt",
    fontIcon: true,
    value: "sua",
  },
  {
    name: "Phân xử lý ý kiến",
    phanXuLyYKien: true,
    icon: "share",
    fontIcon: true,
    value: "pxl-ykien",
  },
  {
    name: "Xóa",
    xoa: true,
    icon: "trash",
    value: "xoa",
  },
  {
    name: "Thêm vào HSLT",
    icon: "file-alt",
    fontIcon: true,
    value: "them-tai-lieu-vao-ho-so-luu-tru",
  },
];

export const DANH_SACH_THAO_TAC_HSCV = [
  {
    name: "Xem luồng phân xử lý",
    icon: "users",
    fontIcon: true,
    value: "xem-luong",
  },
  {
    name: "Duyệt",
    icon: "check-circle",
    value: "duyet",
    fontIcon: true,
  },
  {
    name: "Phân xử lý",
    icon: "share",
    fontIcon: true,
    value: "phan-xu-ly",
  },
  {
    name: "Sửa",
    icon: "pencil-alt",
    fontIcon: true,
    value: "sua",
  },
  {
    name: "Xóa",
    icon: "trash",
    value: "xoa",
  },
  {
    name: "Thêm vào HSLT",
    icon: "file-alt",
    fontIcon: true,
    value: "them-tai-lieu-vao-ho-so-luu-tru",
  },
  {
    name: "Thêm mới hồ sơ bổ sung",
    icon: "file-alt",
    fontSvg: true,
    value: "them-moi-ho-so-bo-sung",
  },
];

export const DANH_SACH_THAO_TAC_NHIEM_VU = [
  {
    name: "Xem luồng phân xử lý",
    icon: "users",
    fontIcon: true,
    value: "xem-luong",
  },
  {
    name: "Cập nhật THTH",
    icon: "edit",
    value: "cap-nhat",
    fontIcon: true,
  },
  {
    name: "Phân xử lý",
    icon: "share",
    fontIcon: true,
    value: "phan-xu-ly",
  },
  {
    name: "Danh sách công việc",
    icon: "newspaper",
    value: "danh-sach-cong-viec",
  },
  {
    name: "Tạo mới công việc",
    icon: "plus-circle",
    fontIcon: true,
    value: "tao-moi-cong-viec",
  },
  {
    name: "Xóa",
    icon: "trash",
    value: "xoa",
  },
  {
    name: "Sửa",
    icon: "pencil-alt",
    fontIcon: true,
    value: "sua",
  },
];

export const DANH_SACH_THAO_TAC_CONG_VIEC = [
  {
    name: "Cập nhật THTH",
    icon: "edit",
    value: "cap-nhat",
    fontIcon: true,
  },
  {
    name: "Sửa",
    icon: "pencil-alt",
    fontIcon: true,
    value: "sua",
  },
  {
    name: "Hủy",
    icon: "ban",
    fontIcon: true,
    value: "huy",
  },
  {
    name: "Lịch sử công việc",
    icon: "history",
    fontIcon: true,
    value: "lich-su-cong-viec",
  },
  {
    name: "Gán công việc",
    icon: "address-card",
    fontIcon: true,
    value: "gan-cong-viec",
  },
  {
    name: "Xóa",
    icon: "trash",
    value: "xoa",
  },
];

export const DANH_SACH_THAO_TAC_HSLT = [
  {
    name: "Sửa",
    icon: "pencil-alt",
    fontIcon: true,
    value: "sua",
  },
  {
    name: "Download",
    icon: "download",
    fontIcon: true,
    value: "download",
  },
  {
    name: "Trình",
    icon: "reply",
    value: "trinh",
    fontIcon: true,
  },
  {
    name: "Trả lại",
    icon: "undo",
    value: "tralai",
    fontIcon: true,
  },
  {
    name: "Phê Duyệt",
    icon: "check",
    value: "pheduyet",
    fontIcon: true,
  },
  {
    name: "Xóa",
    icon: "trash",
    value: "xoa",
  },
];

export const KET_QUA_THUC_HIEN_COLUMNS = [
  {
    rows: [
      {
        name: "Tổng số nhiệm vụ được giao",
        rowspan: 2,
        colspan: null,
        class: "",
      },
      {
        name: "Nhiệm vụ giao tại văn bản không mật",
        rowspan: 2,
        colspan: null,
        class: "",
      },
      {
        name: "Nhiệm vụ giao tại văn bản mật",
        rowspan: 2,
        colspan: null,
        class: "",
      },
      {
        name: "Số nhiệm vụ đã hoàn thành",
        rowspan: null,
        colspan: 2,
        class: "",
      },
      {
        name: "Số nhiệm vụ chưa hoàn thành",
        rowspan: null,
        colspan: 4,
        class: "",
      },
    ],
  },
  {
    rows: [
      {
        name: "Đúng hạn",
        rowspan: null,
        colspan: 1,
        class: "",
      },
      {
        name: "Quá hạn",
        rowspan: null,
        colspan: 1,
        class: "",
      },
      {
        name: "Trong hạn",
        rowspan: null,
        colspan: 1,
        class: "",
      },
      {
        name: "Quá hạn",
        rowspan: null,
        colspan: 1,
        class: "",
      },
    ],
  },
  {
    rows: [
      {
        name: "Là tổng nhiệm vụ CP/TTCP giao (loại nhiệm vụ là Nhiệm vụ CP/VPCP)",
        rowspan: null,
        colspan: null,
        class: "color-red",
      },
      {
        name: "Là tổng số nhiệm vụ CP/TTCP giao với văn bản đến trong phần nhiệm vụ Văn bản giao nhiệm vụ có độ mật là bình thường",
        rowspan: null,
        colspan: null,
        class: "color-red",
      },
      {
        name: "Là tổng số nhiệm vụ CP/TTCP giao với văn bản đến trong phần nhiệm vụ Văn bản giao nhiệm vụ có độ mật là khác bình thường",
        rowspan: null,
        colspan: null,
        class: "color-red",
      },
      {
        name: "Là tổng số nhiệm vụ ở trạng thái hoàn thành với ngày hoàn thành nằm trong kỳ báo có và nhỏ hơn hoặc bằng hạn xử lý hoặc các báo cáo không có hạn xử lý.",
        rowspan: null,
        colspan: null,
        class: "color-red",
      },
      {
        name: "Là tổng số nhiệm vụ ở trạng thái hoàn thành với ngày hoàn thành năm trong kỳ báo cáo  lớn hơn hạn xử lý hoặc các báo cáo không có hạn xử lý.",
        rowspan: null,
        colspan: null,
        class: "color-red",
      },
      {
        name: "Là các nhiệm vụ CP/TTCP có trạng thái khác hoàn thành và có hạn xử lý nhỏ hơn hoặc bằng ngày hiện tại",
        rowspan: null,
        colspan: null,
        class: "color-red",
      },
      {
        name: "Là các nhiệm vụ CP/TTCP có trạng thái khác hoàn thành và có hạn xử lý lơn hơn ngày hiện tại",
        rowspan: null,
        colspan: null,
        class: "color-red",
      },
    ],
  },
  {
    rows: [
      {
        name: "(1) = (2)+(3) = (4)+(5)+(6)+(7)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(2) = (1)-(3)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(3) = (1)-(2)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(4)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(5)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(6)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(7)",
        rowspan: null,
        colspan: null,
        class: "",
      },
    ],
  },
];

export const SO_LUONG_VAN_BAN_COLUMNS = [
  {
    rows: [
      {
        name: "Tên đơn vị",
        rowspan: 3,
        colspan: null,
        class: "w-10",
      },
      {
        name: "Số lượng văn bản gửi (*)",
        rowspan: null,
        colspan: 4,
        class: "",
      },
      {
        name: "Số lượng văn bản nhận (**)",
        rowspan: null,
        colspan: 4,
        class: "",
      },
    ],
  },
  {
    rows: [
      {
        name: "Tổng số",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Văn bản giấy",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Văn bản điện tử không kèm văn bản giấy",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Văn bản điện tử kèm văn bản giấy",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tổng số",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Văn bản giấy",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Văn bản điện tử không kèm văn bản giấy",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Văn bản điện tử kèm văn bản giấy",
        rowspan: 1,
        colspan: null,
        class: "",
      },
    ],
  },
  {
    rows: [
      {
        name: "(1)=(2)+(3)+(4)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(2)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(3)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(4)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(5)=(6)+(7)+(8)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(6)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(7)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(8)",
        rowspan: null,
        colspan: null,
        class: "",
      },
    ],
  },
];

export const SO_LUONG_DON_VI_COLUMNS = [
  {
    rows: [
      {
        name: "Số lượng đơn vị đã gửi, nhận văn bản điện tử",
        rowspan: null,
        colspan: 4,
        class: "",
      },
      {
        name: "Số lượng đơn vị đã xử lý công việc trên môi trường mạng",
        rowspan: null,
        colspan: 4,
        class: "",
      },
      {
        name: "Số lượng vụ, tổng cục, cục và tương đương",
        rowspan: null,
        colspan: 4,
        class: "",
      },
    ],
  },
  {
    rows: [
      {
        name: "Tổng số",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Vụ",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tổng cục, Cục ",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tương đương",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tổng số",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Vụ",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tổng cục, Cục ",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tương đương",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tổng số",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Vụ",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tổng cục, Cục ",
        rowspan: 1,
        colspan: null,
        class: "",
      },
      {
        name: "Tương đương",
        rowspan: 1,
        colspan: null,
        class: "",
      },
    ],
  },
  {
    rows: [
      {
        name: "(1)=(2)+(3)+(4)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(2)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(3)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(4)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(5)=(6)+(7)+(8)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(6)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(7)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(8)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(9)=(10)+(11)+(12)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(10)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(11)",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        name: "(12)",
        rowspan: null,
        colspan: null,
        class: "",
      },
    ],
  },
];

export const DANH_SACH_CD_SO = [
  {
    prop: "stt",
    label: "STT",
    width: "10%",
    headerAlign: "center",
  },
  {
    prop: "noidung",
    label: "Nội dung",
    width: "45%",
    headerAlign: "center",
  },
  {
    prop: "soluong",
    label: "Số lượng",
    width: "15%",
    headerAlign: "center",
  },
  {
    prop: "diemso",
    label: "Điểm số",
    width: "15%",
    headerAlign: "center",
  },
  {
    prop: "diemtoida",
    label: "Điểm tối đa",
    width: "15%",
    headerAlign: "center",
  },
];

export const GIA_TRI_LOAI_BAO_CAO_NHIEM_VU = {
  KQ_THUC_HIEN: "BAO_CAO_1",
  KQ_BO: "BAO_CAO_2",
};

export const DANH_SACH_LOAI_BAO_CAO_NHIEM_VU = [
  {
    value: GIA_TRI_LOAI_BAO_CAO_NHIEM_VU.KQ_THUC_HIEN,
    text: "Báo cáo kết quả thực hiện nhiệm vụ do chính phủ thủ tướng chính phủ",
  },
  {
    value: GIA_TRI_LOAI_BAO_CAO_NHIEM_VU.KQ_BO,
    text: "Báo cáo kết quả thực hiện nhiệm vụ chính phủ, thủ tướng chính phủ giao Bộ",
  },
];

export const DANH_SACH_THANG_TRONG_NAM = [
  {
    text: "Tháng 1",
    value: 1,
  },
  {
    text: "Tháng 2",
    value: 2,
  },
  {
    text: "Tháng 3",
    value: 3,
  },
  {
    text: "Tháng 4",
    value: 4,
  },
  {
    text: "Tháng 5",
    value: 5,
  },
  {
    text: "Tháng 6",
    value: 6,
  },
  {
    text: "Tháng 7",
    value: 7,
  },
  {
    text: "Tháng 8",
    value: 8,
  },
  {
    text: "Tháng 9",
    value: 9,
  },
  {
    text: "Tháng 10",
    value: 10,
  },
  {
    text: "Tháng 11",
    value: 11,
  },
  {
    text: "Tháng 12",
    value: 12,
  },
];

export const DANH_SACH_QUY_TRONG_NAM = [
  {
    text: "Quý 1",
    value: 1,
  },
  {
    text: "Quý 2",
    value: 2,
  },
  {
    text: "Quý 3",
    value: 3,
  },
  {
    text: "Quý 4",
    value: 4,
  },
];

export const DANH_SACH_6_THANG = [
  { id: 1, label: "6 tháng đầu" },
  { id: 2, label: "6 tháng sau" },
];

export const columsReportMission = [
  {
    rows: [
      {
        key: "TenDonVi",
        name: "Cơ quan được giao",
        rowspan: 2,
        colspan: null,
        class: "w-10",
      },
      {
        key: "TongSoVanBanGiaoNhiemVu",
        name: "Tổng số văn bản giao nhiệm vụ",
        rowspan: 2,
        colspan: null,
        class: "",
      },
      {
        key: "TongSo",
        name: "Tổng số nhiệm vụ giao",
        rowspan: 2,
        colspan: null,
        class: "",
      },
      {
        name: "Đã hoàn thành",
        rowspan: null,
        colspan: 2,
        class: "",
      },
      {
        name: "Chưa hoàn thành",
        rowspan: null,
        colspan: 2,
        class: "",
      },
    ],
  },
  {
    rows: [
      {
        key: "HoanThanh_DungHan",
        name: "Đúng hạn",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        key: "HoanThanh_QuaHan",
        name: "Quá hạn",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        key: "ChuaHoanThanh_TrongHan",
        name: "Trong hạn",
        rowspan: null,
        colspan: null,
        class: "",
      },
      {
        key: "ChuaHoanThanh_QuaHan",
        name: "Quá hạn",
        rowspan: null,
        colspan: null,
        class: "",
      },
    ],
  },
];

export const LIST_COLUMN_TABLE_VAN_BAN_DEN = [
  {
    text: "Số đến",
    value: "SoDen",
    width: 70,
    filter: "text",
    bodyStyles: { textAlign: "right" },
  },
  {
    text: "Ngày đến",
    value: "NgayDen",
    filter: "date",
    bodyStyles: { textAlign: "center" },
  },
  {
    text: "Ngày ban hành",
    value: "NgayBanHanh",
    filter: "date",
    bodyStyles: { textAlign: "center" },
  },
  { text: "Số/Ký hiệu", value: "SoKyHieu", filter: "text" },
  { text: "Trích yếu", value: "TrichYeu", width: 300, filter: "text" },
  { text: "Nơi gửi", value: "NoiGui", width: 200, filter: "text" },
  { text: "Loại đến", value: "LoaiDen", filter: "loaiden" },
  { text: "Độ khẩn", value: "DoKhan", filter: "dokhan" },
  { text: "Sổ văn bản", value: "SoVanBan", filter: "sovanban", width: 200 },
  { text: "Loại văn bản", value: "LoaiVanBan", filter: "loaivanban" },
  { text: "Có ký số", value: "HasKySo", filter: "kyso" },
  { text: "Nội dung thu hồi", value: "NoiDungThuHoi", filter: "text" },
  { text: "Tên đơn vị/cá nhân bị thu hồi", value: "TenDonViCaNhanThuHoi", filter: "text", width: 250 },
  { text: "Nội dung trả lại", value: "NoiDungTraLai", filter: "text" },
  { text: "Tên đơn vị/cá nhân trả lại", value: "TenDonViCaNhanTraLai", filter: "text", width: 200 },
  {
    text: "Ngày hoàn thành xử lý",
    value: "NgayHoanThanh",
    filter: "date",
    width: 200,
    bodyStyles: { textAlign: "center" },
  },
  {
    text: "Ngày hạn xử lý",
    value: "HanXuLy",
    filter: "date",
    bodyStyles: { textAlign: "center" },
  },
  {
    text: "Hạn xử lý",
    value: "NgayHanXuLy",
    filter: "text",
    bodyStyles: { textAlign: "right" },
  },
  { text: "Trạng thái xử lý", value: "TrangThaiXuLy", filter: "trangthaixuly" },
  { text: "Người ký", value: "NguoiKy", filter: "text" },
  { text: "Số bản", value: "SoBan", filter: "text", width: 70, bodyStyles: { textAlign: "right" } },
  { text: "Số trang", value: "SoTrang", filter: "text", width: 80, bodyStyles: { textAlign: "right" } },
  {
    text: "Ngày nhận bản giấy",
    value: "NgayNhanBanGiay",
    filter: "date",
    bodyStyles: { textAlign: "center" },
  },
  {
    text: "Chủ trì",
    value: "ChuTri",
    filter: "text",
    width: 130,
  },
  {
    text: "Phối hợp",
    value: "PhoiHop",
    filter: "text",
    width: 130,
  },
];

export const LIST_COLUMN_TABLE_VAN_BAN_DEN_DEFAULT = [
  {
    text: "Số đến",
    value: "SoDen",
    width: 70,
    filter: "text",
    bodyStyles: { textAlign: "right" },
  },
  {
    text: "Ngày đến",
    value: "NgayDen",
    filter: "date",
    bodyStyles: { textAlign: "center" },
  },
  {
    text: "Ngày ban hành",
    value: "NgayBanHanh",
    filter: "date",
    bodyStyles: { textAlign: "center" },
  },
  { text: "Số/Ký hiệu", value: "SoKyHieu", filter: "text" },
  { text: "Trích yếu", value: "TrichYeu", width: 300, filter: "text" },
  { text: "Nơi gửi", value: "NoiGui", width: 200, filter: "text" },
];
